<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import ArrayUtil from '../../utilities/ArrayUtil'
import Cleave from 'cleave.js'
import AppResourceUtil from '../../utilities/AppResourceUtil'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
/** APIs */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
import ValidationCardApi from '../../api/ValidationCardApi'
import ValidationPeriodApi from '../../api/ValidationPeriodApi'
import VfeApi from '../../api/VfeApi'
import ReportingEntityApi from '../../api/ReportingEntityApi'
import ReportingUnitApi from '../../api/ReportingUnitApi'
import VfeFieldAnswerApi from '../../api/VfeFieldAnswerApi'
import ActivityLogsApi from '../../api/ActivityLogsApi'
import FormsApi from '../../api/FormsApi'
import FilesApi from '../../api/FilesApi'
/** Constants */
import { FileTypes } from '../../constants/FileTypes'
import { BACKEND_URL } from '../../constants/ServiceUrl'
/** UI Components */
import { Checkbox } from 'buefy/dist/components/checkbox'
import { Collapse } from 'buefy/dist/components/collapse'
import { Datepicker } from 'buefy/dist/components/datepicker'
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Modal } from 'buefy/dist/components/modal'
import { Radio } from 'buefy/dist/components/radio'
import { Select } from 'buefy/dist/components/select'
import { Tabs,TabItem } from 'buefy/dist/components/tabs'
import { Upload } from 'buefy/dist/components/upload'
import { Loading } from 'buefy/dist/components/loading'
import { Tag } from 'buefy/dist/components/tag'
import { Message } from 'buefy/dist/components/message'

import Timer from '../../components/TimeRemaining'
import SummaryTab from '../../components/SummaryTab'
/**
 * We add a new instance of Cleave when the element
 * is bound and destroy it when it's unbound.
 */
const cleave = {
    name: 'cleave',
    bind(el, binding) {
        const input = el.querySelector('input')
        input._vCleave = new Cleave(input, binding.value)
    },
    unbind(el) {
        const input = el.querySelector('input')
        input._vCleave.destroy()
    }
}

const VCARD_SECTION_LOG = 'Validation Card';
const VFE_SECTION_LOG = 'Validation Card - Form Entry';
const MAX_FILESIZE_TOTAL = 1e+8;
const MAX_NUM_FILES = 20;

export default {
    name : "WorkspaceView",
    components : {
        'b-checkbox' : Checkbox,
        'b-collapse' : Collapse,
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-select' : Select,
        'b-modal' : Modal,
        'b-tabs' : Tabs,
        'b-tab-item' : TabItem,
        'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,
        'b-datepicker' : Datepicker,
        'b-radio' : Radio,
        'b-loading' : Loading,
        'b-upload' : Upload,
        'b-tag' : Tag,
        'b-message' : Message,
        Timer,
        SummaryTab
    },
    directives: { cleave },
	computed : {
		...mapState({
            activeNav : "activeNav",
            profile : "userProfile",
            token : "xOreAuth"
        }),
        profileHandles () {
            var repGroupIds = []
            var repEntityIds = []
            var repUnitIds = []
            if (this.profile) {
                if (this.profile.reportingGroups && this.profile.reportingGroups.length > 0) {
                    repGroupIds = this.profile.reportingGroups.map(g => {
                        return g.repGroupIdFk
                    })
                }
                if (this.profile.reportingEntities && this.profile.reportingEntities.length > 0) {
                    repEntityIds = this.profile.reportingEntities.map(e => {
                        return e.repEntityIdFk
                    })
                }
                if (this.profile.reportingUnits && this.profile.reportingUnits.length > 0) {
                    repUnitIds = this.profile.reportingUnits.map(u => {
                        return u.repUnitIdFk
                    })
                }
            }
            return {
                repGroupIds,
                repEntityIds,
                repUnitIds
            }
        },
        profileHandlesData () {
            var repGroups = []
            var repEntities = []
            var repUnits = []
            if (this.profile) {
                if (this.profile.reportingGroups && this.profile.reportingGroups.length > 0) {
                    repGroups = this.profile.reportingGroups
                }
                if (this.profile.reportingEntities && this.profile.reportingEntities.length > 0) {
                    repEntities = this.profile.reportingEntities.map(en => {
                        return {
                            repGroupIdFk: en.repGroupIdFk,
                            repEntityIdFk: en.repEntityIdFk,
                            repUnitIdFk: en.repUnitIdFk,
                        }
                    })
                }
                if (this.profile.reportingUnits && this.profile.reportingUnits.length > 0) {
                    repUnits = this.profile.reportingUnits.map(un => {
                        return {
                            repGroupIdFk: un.repGroupIdFk,
                            repEntityIdFk: un.repEntityIdFk,
                            repUnitIdFk: un.repUnitIdFk,
                        }
                    })
                }
            }
            return {
                repGroups,
                repEntities,
                repUnits
            }
        },
        groupedFields(){
            if (this.selectedVfe) {
                let currFieldGroup=null;
                let newGroupedFields = [];
                if ( this.selectedVfe.formFields ) {
                    if ( this.selectedVfe.formFields.length > 0) {
                        this.selectedVfe.formFields.forEach(field=>{
                            if (field.fieldGroupLabel==currFieldGroup && field.fieldGroupLabel!="") {
                                newGroupedFields[newGroupedFields.length-1].fields.push(field)
                            }
                            else {
                                newGroupedFields.push({
                                    fieldGroupName: field.fieldGroupLabel,
                                    fieldGroupSubLabel: field.fieldGroupSubLabel ? field.fieldGroupSubLabel : '',
                                    fields : [field]
                                })
                            }
                            currFieldGroup = field.fieldGroupLabel;
                        });
                    }
                } 
                return newGroupedFields;
            }
        },
        filterValidationEntryForms(){
            var searchKeyword = this.searchFormKeyword;
            var searchExp = new RegExp(searchKeyword,"i");
            if (this.vcardForms) {
                if (this.vcardForms.length > 0) {
                    return this.vcardForms.filter(form=>{
                        return (form.formName!=null && form.formName.match(searchExp));
                    });
                }
            }
        },
        fValue: {
            get:function(){ 
                return this.taxValue;
            },
            set:function(newValue) {
                this.taxValue = newValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
                // Source:
                // https://blog.abelotech.com/posts/number-currency-formatting-javascript/
                // https://codesandbox.io/s/p7j447k7wq
            }
        },
        vcardDisplayName(){
            if (this.selectedValidationCard) {
                if (this.selectedValidationCard.reportingUnit) {
                    return this.selectedValidationCard.reportingUnit;
                }
                return this.selectedValidationCard.reportingEntity;
            }
        },
        isVfeValid(){
            let errorCount = 0;
            if (this.selectedVfe) {
                if (this.selectedVfe.formFields) {
                    if (this.selectedVfe.formFields.length > 0) {
                        this.selectedVfe.formFields.forEach(field=>{
                            if (field.inputType=='checkbox') {
                                if (field.isRequired && field.fieldAnswerValue.length == 0) {
                                    // console.log("error checkbox")
                                    errorCount ++;
                                }
                            }
                            else if (field.dataType=='string') {
                                if (field.isRequired && field.fieldAnswerValue.trim().length==0) {
                                    // console.log("error string")
                                    errorCount ++;
                                }
                            }
                            else if (field.inputType=='decimal') {
                                if (field.isRequired && (field.fieldAnswerValue=='' || field.fieldAnswerLabel==null)) {
                                    // console.log("error decimal")
                                    errorCount ++;
                                }
                            }
                            else if (field.inputType=='number') {
                                if (field.isRequired && (field.fieldAnswerValue=='' || field.fieldAnswerLabel==null)) {
                                    // console.log("error decimal")
                                    errorCount ++;
                                }
                            }
                            else {
                                if (field.isRequired && (field.fieldAnswerValue=='' || field.fieldAnswerValue==null) ) {
                                    // console.log(field.inputType);
                                    // console.log(field.fieldAnswerValue)
                                    // console.log("error everything else")
                                    errorCount ++;
                                }
                            }
                        })
                    }
                }
            }
            if (errorCount > 0) {
                return false
            }
            return true
        },
        hasChangedFields(){
            if (this.selectedVfe) {
                if (!this.selectedVfe.changedFields) {
                    return false
                }
                this.selectedVfe.changedFields = [];
                if (this.selectedVfe.formFields) {
                    this.selectedVfe.formFields.forEach(field=>{
                        if (field.dataType!=='date') {
                            if (field.inputType!=='checkbox') {
                                if (field.fieldAnswerValue!==field.originalFieldAnswerValue) {
                                    this.selectedVfe.changedFields.push(field)
                                }
                            }
                            else {
                                if (JSON.stringify(field.fieldAnswerValue)!=JSON.stringify(field.originalFieldAnswerValue)) {
                                    this.selectedVfe.changedFields.push(field)
                                }
                            }
                        }
                        else {
                            if (field.fieldAnswerValue != null) {
                                if ( this.$moment(field.fieldAnswerValue).format('YYYY-MM-DD')!= field.originalFieldAnswerValue ) {
                                    this.selectedVfe.changedFields.push(field);
                                }
                            }
                        }
                    })
                }

                if (this.selectedVfe.changedFields.length > 0) {
                    return true;
                }

                if (this.selectedForm.filesEnabled) {
                    if (this.dropFiles.length > 0){
                        return true;
                    }
                }
            }
            return false;
        },
        baseUrl(){
            return BACKEND_URL;
        },
        dueDateEpoch(){
            if (this.validationPeriod) {
                if (this.validationPeriod.dueDate!=null) {
                    return parseInt(this.$moment(this.validationPeriod.dueDate,'YYYY-MM-DD HH:mm:ss').format('x'),10)
                }
            }
            return null;
        },
        hasChangesNewEntry(){
            if (this.selectedVfe && !this.selectedVfe.vcardFormEntryId) {
                if (this.selectedVfe.formFields.length > 0) {
                    let changedFields = this.selectedVfe.formFields.filter(f=>{
                        return f.fieldAnswerValue!=f.originalFieldAnswerValue;
                    });
                    if (changedFields.length > 0) {
                        return true;
                    }
                }
            }
            return false;
        },
        hasChangesVfeInTable(){
            var countChanged = 0;
            if (this.selectedForm && this.displayOption=='Table') {
                if (this.selectedForm.vfe.length > 0) {
                    this.selectedForm.vfe.forEach(vfe=>{
                        if (vfe.formFields && vfe.formFields.length > 0) {
                            let changedFields = vfe.formFields.filter(f=>{
                                return f.fieldAnswerValue!=f.originalFieldAnswerValue
                            });
                            countChanged += changedFields.length;
                        }
                    })
                }
            }
            if (countChanged > 0) {
                return true;
            }
            return false;
        },
        totalFileSize() {
            if (this.dropFiles.length > 0) {
                var total = this.dropFiles.reduce((acc, file) => acc + file.size, 0);
                return AppResourceUtil.convertFileSize(total)
            } 
            return AppResourceUtil.convertFileSize(0)
        }
        /*,multipleVfeChangesInTable(){
            var countChanged = 0;
            let vfes = [];
            if (this.selectedForm && this.displayOption=='Table') {
                if (this.selectedForm.vfe.length > 0) {
                    vfes = this.selectedForm.vfe.filter(vfe=>{
                        if (vfe.formFields && vfe.formFields.length > 0) {
                            let changedFields = vfe.formFields.filter(f=>{
                                return f.fieldAnswerValue!=f.originalFieldAnswerValue
                            });
                            return changedFields.length > 0;
                        }
                    });
                }
            }
            if (vfes.length > 1) {
                return true
            }
            return false;
        }*/
    },
    data(){
        return {
            activeTab : 0,
            activeFormEntry: null,
            activeValidationEntry : null,
            displayOption : "",
            formTableColumns : [],
            selectedForm: null,
            searchFormKeyword: "",
            taxValue: "",


            selectedValidationCardId : null,
            selectedValidationCard : null,
            vcardForms : [],
            selectedReportingYear : null,
            reportingYearLov : [],
            inProgressVcards : [],
            selectedVfe : null,
            vfePromiseLoading : false,
            presetLovs: {
                'Reporting Entities' : [],
                'Reporting Entities & Units' : []
            },
            showList : true,
            masks: {
                numeral: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                    prefix: '',
                    rawValueTrimPrefix : true
                }
            },
            dropFiles : [],
            fileUploadError : false,
            fileUploadErroMsg : "",
            openVfeFilesDialog : false,
            openedVfe : null,
            isLoading : false,
            isFullPage : false,
            validationPeriod : null,
            currentYear : null,
            currentVcardId : null,
            maxNumFiles: MAX_NUM_FILES,
            errorFields: [],
            globalLoading: null
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        this.isTokenValid();
    },
	beforeMount() {
		window.addEventListener("beforeunload", this.preventLeave)
	},
	beforeDestroy() {
		window.removeEventListener("beforeunload", this.preventLeave);
	},
	beforeRouteLeave(to, from, next) {
        if (this.displayOption=='List') {
            if (this.hasChangedFields || this.hasChangesNewEntry) {
                this.$dialog.confirm({
                    title: "You have unsaved changes ",
                    message: "Looks like you're navigating away from this page. To continue with data entry, click 'Continue editing'. Othewise, click 'Discard Changes'.",
                    cancelText: "Discard Changes",
                    confirmText: "Continue editing",
                    type: 'is-warning',
                    onConfirm: () => {
                        // stay
                    },
                    onCancel: ()=>{
                        // navigate away
                        next();
                    }
                });
                return;
            }
        }
        else if (this.displayOption=='Table') {
            if (this.hasChangesVfeInTable) {
                this.$dialog.confirm({
                    title: "You have unsaved changes",
                    message: "Looks like you're navigating away from this page. To continue with data entry, click 'Continue editing'. Othewise, click 'Discard Changes'.",
                    cancelText: "Discard Changes",
                    confirmText: "Continue editing",
                    type: 'is-warning',
                    onConfirm: () => {
                        // stay
                    },
                    onCancel: ()=>{
                        // navigate away
                        next();
                    }
                });
                return;
            }
        }
		
		next();
	},  
    methods : {
        ...mapMutations({
            clearAppData : "clearAppData",
            setActiveNav : "updateActiveNav",
            setProfile : "updateUserProfile"
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            this.isLoading = true;
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.isLoading = false;
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created 
                                let vcardId = '';
                                let vcardYear = null;
                                if (this.$route.query) {
                                    try {
                                        vcardId = this.$route.query.validationCardId;
                                    }
                                    catch(cardId){}            

                                    try {
                                        vcardYear = this.$route.query.reportingYear;
                                    }
                                    catch(cardId){}            
                                }
                            
                                this.getReportingYearLov(vcardId,vcardYear);
                                this.getPresetLovs();
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                } 
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getPresetLovs(){
            this.presetLovs['Reporting Entities'] = [];
            this.presetLovs['Reporting Entities & Units'] = [];

            /* Reporting Entities Preset */ 
            ReportingEntityApi.get('active')
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        let entities = response.data;
                        if (entities.length > 0) {
                            entities.forEach(ent=>{
                                ent.optionLabel = ent.reportingEntity
                            });
                        }
                        this.presetLovs['Reporting Entities'] = entities;
                    }
                    else {
                        this.promptServerError({response},'ReportingEntity.get');
                        return false;
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingEntity.get');
                return false;
            });

            /* Reporting Entities & Units Preset */ 
            ReportingUnitApi.getUnitsEntities()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        let entities = response.data;
                        if (entities.length > 0) {
                            entities.forEach(ent=>{
                                ent.optionLabel = (ent.reportingUnit!=null && ent.reportingUnit!='') ? ent.reportingUnit : ent.reportingEntity 
                            });
                        }
                        this.presetLovs['Reporting Entities & Units'] = entities;
                    }
                    else {
                        this.promptServerError({response},'ReportingUnit.getUnitsEntities');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingUnit.getUnitsEntities');
            });
        },
        getReportingYearLov(vcardId,vcardYear){
            this.isLoading = true;
            this.reportingYearLov = [];
            let staticYrs = AppResourceUtil.getRepYrStaticLov();
    
            ValidationCardApi.getReportingYearLov()
            .then(response=>{
                let repYearInDb = [];
                if (response.data) {
                    if (!response.data.error) {

                        if (response.data.length > 0) {
                            repYearInDb = response.data.map(yr=>{
                                return (yr.reportingYear);
                            });
                        }
                        
                        /* Merge static years and rep year found in the database */ 
                        let allRepYrsLov = this.$_.union(staticYrs,repYearInDb);

                        /* Sort the years in descending order */ 
                        this.reportingYearLov = allRepYrsLov.sort().reverse();

                        if (!vcardYear) {
                            if (repYearInDb > 0) {
                                try {
                                    /* Pre-select the year with data (from DB) */ 
                                    this.selectedReportingYear = repYearInDb[0];
                                    this.currentYear = repYearInDb[0];
                                }
                                catch(yrErr){}
                            }
                        }
                        else {
                            this.selectedReportingYear = vcardYear;
                            this.currentYear = vcardYear;
                        }

                        if (this.selectReportingYear != null) {
                            this.getValidationPeriod();
                            this.getInProgressVcards(vcardId);
                        }
                        else {
                            /** If there's no selected year, stop loading indicator */
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getReportingYearLov');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getReportingYearLov');
            });
        },
        getValidationPeriod(){
            if (!this.selectedReportingYear) {
                return false;
            }
            /** This is called to get the due date and show timer in workspace */
            this.validationPeriod = null;

            ValidationPeriodApi.get({
                reportingYear : this.selectedReportingYear,
                status : ''
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length == 0) {
                            // No validation period
                        }
                        else {
                            if (response.data[0]) {
                                this.validationPeriod  = response.data[0];
                            }  
                        }
                    }
                    else {
                        this.promptServerError({response},'ValidationPeriod.get');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ValidationPeriod.get');
            });
        },
        getInProgressVcards(vcardId){
            this.inProgressVcards = [];
            ValidationCardApi.getInProgress({
                userId : this.profile.userId,
                repGroupIdFk : this.profile.repGroupIdFk,
                repEntityIdFk : this.profile.repEntityIdFk,
                repUnitIds: this.profileHandles.repUnitIds,
                reportingYear : this.selectedReportingYear,
                repGroupData: this.profileHandlesData.repGroups,
                repEntityData: this.profileHandlesData.repEntities,
                repUnitData: this.profileHandlesData.repUnits
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error){
                        this.inProgressVcards = response.data.vcards;
                        if (vcardId!='' && vcardId!==undefined) {
                            if (this.inProgressVcards.length > 0) {
                                this.selectedValidationCardId = parseInt(vcardId,10)
                                this.currentVcardId = vcardId;
                                this.getValidationCard('start');
                            }
                        }
                        else {
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getInProgress');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getInProgress');
            });
        },
        getValidationCard(trigger,vcardFormEntryId,calledBy){
            if (!this.selectedValidationCardId) {
                return false;
            }
            this.isLoading = true;
            this.vcardForms = [];
            ValidationCardApi.get(this.selectedValidationCardId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.validationCard.length == 1) {
                            this.selectedValidationCard = response.data.validationCard[0];
                        }
                        this.selectedReportingYear = this.selectedValidationCard.reportingYear;
                        // this.vcardForms = response.data.uniqueForms;
                        this.vcardLogs = [];

                        /** Convert dates */
                        var vcardForms = response.data.uniqueForms;
                        vcardForms.forEach(vform=>{
                            if (vform.vfe.length > 0) {
                                vform.vfe.forEach(vcardFormEntry=>{
                                    vcardFormEntry.dateLastUpdated = AppResourceUtil.convertDate(vcardFormEntry.dateLastUpdated)
                                    vcardFormEntry.dateGenerated = AppResourceUtil.convertDate(vcardFormEntry.dateGenerated)
                                })
                            }
                        })
                        this.vcardForms = vcardForms;

                        /** Parse logs */
                        if (response.data.logs.length > 0) {
                            let logs = response.data.logs;
                            logs.forEach(log=>{
                                if (log.activityMessageLog=='Changed fields.' ||
                                    log.activityMessageLog=='Saved form entry. Changed fields.'){
                                    log['changedFields'] = JSON.parse(log.activityBody);
                                }
                                if (log.activityReason!=null && log.activityRequestedBy!=null) {
                                    log.additionalInfo = JSON.parse(log.activityBody);
                                }
                                /** Convert Date */
                                log.activityDate = AppResourceUtil.convertDate(log.activityDate)
                            });
                            this.vcardLogs = logs;
                        }
                        this.isLoading = false;
                        if (trigger=='newVfe') {
                            /* Highlight newly-added VFE */ 
                            if (vcardFormEntryId!==undefined) {
                                let currVfe = [];
                                if (this.vcardForms.length > 0) {
                                    this.vcardForms.forEach(form=>{
                                        if (form.vfe.length > 0) {
                                            form.vfe.forEach(vfe=>{
                                                if (vfe.vcardFormEntryId==vcardFormEntryId) {
                                                    currVfe.push({
                                                        vfe : vfe,
                                                        form : form
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                                if (currVfe.length > 0) {
                                    // Pre-select newly-created vfe
                                    if (this.selectedForm) {
                                        if (this.selectedForm.displayOption=='List') {
                                            if (!calledBy) {
                                                this.openFormEntry(
                                                    currVfe[0].vfe,
                                                    currVfe[0].form
                                                );
                                            }
                                        }
                                        else {
                                            this.openFormTable(currVfe[0].form);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.get');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.get');
            });
        },
        selectReportingYear(evt,year){
            if (this.unsavedChanges()) {
                this.$dialog.confirm({
                    title: "You have unsaved changes",
                    message: "Changing the reporting year might lose your unsaved changes. To continue with data entry, click 'Continue editing'. Othewise, click 'Discard Changes'.",
                    cancelText: "Discard Changes",
                    confirmText: "Continue editing",
                    type: 'is-warning',
                    onConfirm: () => {
                        // stay
                        this.selectedReportingYear = this.currentYear;
                    },
                    onCancel: ()=>{
                        this.selectedValidationCard = null
                        this.selectedValidationCardId = null
                        this.selectedVfe = null

                        this.getInProgressVcards();
                        this.currentYear = year;
                    }
                });
                return false
            }

            this.selectedValidationCard = null
            this.selectedValidationCardId = null
            this.selectedVfe = null

            this.getInProgressVcards();
            this.currentYear = year;
        },
        selectVcard(vcard){
            // Add restriction code
            if (this.unsavedChanges()) {
                this.$dialog.confirm({
                    title: "You have unsaved changes",
                    message: "Switching validation card might lose your unsaved changes. To continue with data entry, click 'Continue editing'. Othewise, click 'Discard Changes'.",
                    cancelText: "Discard Changes",
                    confirmText: "Continue editing",
                    type: 'is-warning',
                    onConfirm: () => {
                        // stay
                        this.selectedValidationCardId = this.currentVcardId
                    },
                    onCancel: ()=>{
                        this.selectedForm = null;
                        this.selectedVfe = null;
                        if (this.selectedValidationCardId!=null) {
                            this.getValidationCard('start');
                        }
                        this.currentVcardId = vcard.validationCardId;
                    }
                });
                return false
            }

            this.selectedForm = null;
            this.selectedVfe = null;
            if (this.selectedValidationCardId!=null) {
                if (typeof(this.selectedValidationCardId)=='string') {
                    this.selectedValidationCardId = parseInt(this.selectedValidationCardId, 10)
                }
                this.getValidationCard('start');
            }
            this.currentVcardId = vcard.validationCardId;
        },
        toggleList(){
            this.showList = !this.showList;
        },
        changeDisplay(option){
            let prevOption = this.displayOption;

            if (this.unsavedChanges()) {
                this.$dialog.confirm({
                    title: "You have unsaved changes",
                    message: "Switching your view might lose unsaved changes. To continue with data entry, click 'Continue editing'. Othewise, click 'Discard Changes'.",
                    cancelText: "Discard Changes",
                    confirmText: "Continue editing",
                    type: 'is-warning',
                    onConfirm: () => {
                        // stay
                    },
                    onCancel: ()=>{
                        if (this.selectedForm) {
                            if (prevOption=='Table' && option=='List') {
                                if (this.selectedForm.vfe.length > 0) {
                                    try {
                                        this.openFormEntry(this.selectedForm.vfe[0],this.selectedForm,'changeDisplay');
                                    }
                                    catch(err) {
                                    }
                                }
                                this.displayOption = option;
                            }
                            else {
                                if (this.selectedVfe) {
                                    this.selectedVfe = null;
                                }
                                /** this.selectedForm.formSubmissionType=='Single' */
                                if (this.selectedForm.vfe.length > 0) {
                                    try {
                                        this.vfePromiseLoading = true;
                                        this.openFormTable(this.selectedForm,option);
                                    }
                                    catch(vfeFormErr){}
                                }
                            }
                            
                        } 
                    }
                });
                return false
            }

            if (this.selectedForm) {
                if (prevOption=='Table' && option=='List') {
                    if (this.selectedForm.vfe.length > 0) {
                        try {
                            this.openFormEntry(this.selectedForm.vfe[0],this.selectedForm,'changeDisplay');
                        }
                        catch(err) {
                        }
                    }
                    this.displayOption = option;
                }
                else {
                    if (this.selectedVfe) {
                        this.selectedVfe = null;
                    }
                    /** this.selectedForm.formSubmissionType=='Single' */
                    if (this.selectedForm.vfe.length > 0) {
                        try {
                            this.vfePromiseLoading = true;
                            this.openFormTable(this.selectedForm,option);
                        }
                        catch(vfeFormErr){}
                    }
                }
                
            }   
        },
        openFormEntry(vfe,form,trigger){
            // Add changes restriction code here
            if (this.unsavedChanges()) {    
                if ( ( (this.selectedVfe && vfe) && (this.selectedVfe.vcardFormEntryId!=vfe.vcardFormEntryId) ) ||
                    ( (this.selectedForm && form) && (this.selectedForm.formIdFk!=form.formIdFk) ) )  {
                    this.$dialog.confirm({
                        title: "You have unsaved changes",
                        message: "Navigating to another form might lose your unsaved changes. To continue with data entry, click 'Continue editing'. Othewise, click 'Discard Changes'.",
                        cancelText: "Discard Changes",
                        confirmText: "Continue editing",
                        type: 'is-warning',
                        onConfirm: () => {
                        },
                        onCancel: ()=>{
                            this.vfePromiseLoading = true;
                            if (!trigger || !this.selectedForm || 
                                (this.selectedForm && this.selectedForm.formIdFk!==form.formIdFk)) {
                                this.selectedForm = form;
                                if (form.displayOption) {
                                    this.displayOption = form.displayOption;
                                }
                            }

                            VfeApi.get(vfe.vcardFormEntryId,vfe.formIdFk)
                            .then(response=>{
                                
                                this.selectedVfe = vfe;
                                this.$set(this.selectedVfe,'formFields',[]);
                                this.$set(this.selectedVfe,'files',[]);
                                
                                if (response.data) {
                                    if (!response.data.error) {
                                        if (response.data.fields) {
                                            this.$set(this.selectedVfe,'formFields',response.data.fields);
                                            /* Parse date field to be consumed by the datepicker element */
                                            if (this.selectedVfe.formFields) {
                                                this.selectedVfe.formFields.forEach(field=>{
                                                    if (field.dataType=='string' && field.fieldAnswerValue==null) {
                                                        field.fieldAnswerValue = "";
                                                    }
                                                    if (field.dataType=='date') {
                                                        if (field.fieldAnswerValue!="" && field.fieldAnswerValue!=null) {
                                                            field.fieldAnswerValue = new Date(field.fieldAnswerValue);
                                                        } else if (field.fieldAnswerLabel != '' && field.fieldAnswerLabel !==null) {
                                                            field.fieldAnswerValue = new Date(field.fieldAnswerLabel);
                                                        } else {
                                                            field.fieldAnswerValue = null
                                                        }
                                                    }
                                                })
                                            }
                                        }
                                        /* 
                                        If there are existing answers already, add 'changedFields' property
                                        for that form entry. This is where changed fields will be pushed.
                                        */ 
                                        if (response.data.hasAnswers) {
                                            this.$set(this.selectedVfe,'changedFields',[]);
                                        }
                                        /* If there are uploaded files for this entry*/ 
                                        if (response.data.files) {
                                            // this.$set(this.selectedVfe,'files',response.data.files);
                                            let formEntryFiles = response.data.files;
                                            formEntryFiles.forEach(f=>{
                                                /** Convert data */
                                                f.dateUploaded = AppResourceUtil.convertDate(f.dateUploaded)
                                            })
                                            this.$set(this.selectedVfe,'files',formEntryFiles);
                                        }
                                    } 
                                    else {
                                        this.promptServerError({response},'Vfe.get');
                                    }
                                }
                                this.vfePromiseLoading = false;
                            })
                            .catch(error=>{
                                this.vfePromiseLoading = false;
                                this.promptServerError(error,'Vfe.get');
                            });
                        }
                    });
                    return false
                }
                else {
                    return false;
                }
            
            }

            this.vfePromiseLoading = true;
            if (!trigger || !this.selectedForm || 
                (this.selectedForm && this.selectedForm.formIdFk!==form.formIdFk)) {
                this.selectedForm = form;
                if (form.displayOption) {
                    this.displayOption = form.displayOption;
                }
            }

            VfeApi.get(vfe.vcardFormEntryId,vfe.formIdFk)
            .then(response=>{
                
                this.selectedVfe = vfe;
                this.$set(this.selectedVfe,'formFields',[]);
                this.$set(this.selectedVfe,'files',[]);
                
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.fields) {
                            this.$set(this.selectedVfe,'formFields',response.data.fields);
                            /* Parse date field to be consumed by the datepicker element */
                            if (this.selectedVfe.formFields) {
                                this.selectedVfe.formFields.forEach(field=>{
                                    if (field.dataType=='string' && field.fieldAnswerValue==null) {
                                        field.fieldAnswerValue = ""
                                    }
                                    if (field.dataType=='date') {
                                        if (field.fieldAnswerValue!="" && field.fieldAnswerValue!=null) {
                                            field.fieldAnswerValue = new Date(field.fieldAnswerValue);
                                        } else if (field.fieldAnswerLabel != '' && field.fieldAnswerLabel !==null) {
                                            field.fieldAnswerValue = new Date(field.fieldAnswerLabel);
                                        } else {
                                            field.fieldAnswerValue = null
                                        }
                                    }
                                })
                            }
                        }
                        /* 
                        If there are existing answers already, add 'changedFields' property
                        for that form entry. This is where changed fields will be pushed.
                        */ 
                        if (response.data.hasAnswers) {
                            this.$set(this.selectedVfe,'changedFields',[]);
                        }
                        /* If there are uploaded files for this entry*/ 
                        if (response.data.files) {
                            // this.$set(this.selectedVfe,'files',response.data.files);
                            let formEntryFiles = response.data.files;
                            formEntryFiles.forEach(f=>{
                                /** Convert data */
                                f.dateUploaded = AppResourceUtil.convertDate(f.dateUploaded)
                            })
                            this.$set(this.selectedVfe,'files',formEntryFiles);
                        }
                    } 
                    else {
                        this.promptServerError({response},'Vfe.get');
                    }
                }
                this.vfePromiseLoading = false;
            })
            .catch(error=>{
                this.vfePromiseLoading = false;
                this.promptServerError(error,'Vfe.get');
            });
        },

        addFormEntry(form,trigger){
            // Add unsaved changes restriction
            if (this.unsavedChanges()) {
                this.$dialog.confirm({
                    title: "You have unsaved changes",
                    message: "Adding new form entry might lose your unsaved changes. To continue with data entry, click 'Continue editing'. Othewise, click 'Discard Changes'.",
                    cancelText: "Discard Changes",
                    confirmText: "Continue editing",
                    type: 'is-warning',
                    onConfirm: () => {
                        // stay
                    },
                    onCancel: ()=>{
                        if (this.displayOption=='List') {
                
                            // For list display behavior
                            let useRepYear = this.selectedReportingYear;
                            if (form.reportingYear) {
                                useRepYear = form.reportingYear;
                            }

                            if (trigger) {
                                // if (!this.selectedForm) {
                                    this.selectedForm = form;
                                // }
                            }

                            this.vfePromiseLoading = true;
                            VfeApi.getNewEntry(form.formIdFk)
                            .then(response=>{
                                if (response.data) {
                                    if (!response.data.error) {
                                        this.selectedVfe = {};
                                        this.$set(this.selectedVfe,'accessIdFk',form.accessIdFk);
                                        this.$set(this.selectedVfe,'reportingYear',useRepYear);
                                        this.$set(this.selectedVfe,'formIdFk',form.formIdFk);
                                        this.$set(this.selectedVfe,'formName',form.formName);
                                        this.$set(this.selectedVfe,'formSubmissionType',form.formSubmissionType);
                                        this.$set(this.selectedVfe,'displayOption',form.displayOption);
                                        this.$set(this.selectedVfe,'sequenceNumber',form.sequenceNumber);
                                        this.$set(this.selectedVfe,'formFields',response.data);
                                        if (this.selectedForm && this.selectedForm.filesEnabled==true) {
                                            this.$set(this.selectedVfe,'files',[]);
                                        }
                                        this.vfePromiseLoading = false;
                                    }
                                    else {
                                        this.vfePromiseLoading = false;
                                        this.promptServerError({response},'Vfe.getNewEntry');
                                    }
                                }
                            })
                            .catch(error=>{
                                this.vfePromiseLoading = false;
                                this.promptServerError(error,'Vfe.getNewEntry');
                            });
                        }
                        else {
                            //if (this.displayOption=='' && trigger=='list') {
                            if (trigger=='list') {
                                this.addVfeForMultitpleList('list',form);
                                return false
                            }
                            // For table view behavior for adding new entry
                            this.addFormTableEntry('list');
                        }
                    }
                });
                return false
            }

            // Actual code
            if (this.displayOption=='List') {
                
                // For list display behavior
                let useRepYear = this.selectedReportingYear;
                if (form.reportingYear) {
                    useRepYear = form.reportingYear;
                }

                if (trigger) {
                    // if (!this.selectedForm) {
                        this.selectedForm = form;
                    // }
                }

                this.vfePromiseLoading = true;
                VfeApi.getNewEntry(form.formIdFk)
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {
                            this.selectedVfe = {};
                            this.$set(this.selectedVfe,'accessIdFk',form.accessIdFk);
                            this.$set(this.selectedVfe,'reportingYear',useRepYear);
                            this.$set(this.selectedVfe,'formIdFk',form.formIdFk);
                            this.$set(this.selectedVfe,'formName',form.formName);
                            this.$set(this.selectedVfe,'formSubmissionType',form.formSubmissionType);
                            this.$set(this.selectedVfe,'displayOption',form.displayOption);
                            this.$set(this.selectedVfe,'sequenceNumber',form.sequenceNumber);
                            this.$set(this.selectedVfe,'formFields',response.data);
                            if (this.selectedForm && this.selectedForm.filesEnabled==true) {
                                this.$set(this.selectedVfe,'files',[]);
                            }
                            this.vfePromiseLoading = false;
                        }
                        else {
                            this.vfePromiseLoading = false;
                            this.promptServerError({response},'Vfe.getNewEntry');
                        }
                    }
                })
                .catch(error=>{
                    this.vfePromiseLoading = false;
                    this.promptServerError(error,'Vfe.getNewEntry');
                });
            }
            else {
                //if (this.displayOption=='' && trigger=='list') {
                if (trigger=='list') {
                    this.addVfeForMultitpleList('list',form);
                    return false
                }
                // For table view behavior for adding new entry
                this.addFormTableEntry('list');
            }
        },
        addVfeForMultitpleList(display,formFromListView) {
            if (display=='list' && formFromListView) {
                this.vfePromiseLoading = true;

                this.selectedForm = formFromListView;
                if (formFromListView.displayOption) {
                    this.displayOption = formFromListView.displayOption;
                }
            
                // For list display behavior
                let useRepYear = this.selectedReportingYear;
                if (formFromListView.reportingYear) {
                    useRepYear = formFromListView.reportingYear;
                }

                VfeApi.getNewEntry(formFromListView.formIdFk)
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {

                            this.selectedVfe = {};
                            let formFields = response.data;
                                
                            /* Parse date field to be consumed by the datepicker element */
                            if (formFields.length > 0) {
                                formFields.forEach(currField=>{
                                    if (currField.dataType=='string' && currField.fieldAnswerValue==null) {
                                        currField.fieldAnswerValue = "";
                                    }
                                    if (currField.dataType=='date') {
                                        if (currField.fieldAnswerValue!="" && currField.fieldAnswerValue!=null) {
                                            currField.fieldAnswerValue = new Date(currField.fieldAnswerValue);
                                        }  else if (currField.fieldAnswerLabel != '' && currField.fieldAnswerLabel !==null) {
                                            currField.fieldAnswerValue = new Date(currField.fieldAnswerLabel);
                                        } else {
                                            currField.fieldAnswerValue = null
                                        }
                                    }
                                });
                            }
                            
                            this.$set(this.selectedVfe,'accessIdFk',formFromListView.accessIdFk);
                            this.$set(this.selectedVfe,'reportingYear',useRepYear);
                            this.$set(this.selectedVfe,'formIdFk',formFromListView.formIdFk);
                            this.$set(this.selectedVfe,'formName',formFromListView.formName);
                            this.$set(this.selectedVfe,'formSubmissionType',formFromListView.formSubmissionType);
                            this.$set(this.selectedVfe,'displayOption',formFromListView.displayOption);
                            this.$set(this.selectedVfe,'sequenceNumber',formFromListView.sequenceNumber);
                            this.$set(this.selectedVfe,'formFields',formFields);
                            this.$set(this.selectedVfe,'changedFields',[]);       
                            if (this.selectedForm && this.selectedForm.filesEnabled==true) {
                                this.$set(this.selectedVfe,'files',[]);
                            }
                            this.vfePromiseLoading = false;
                        }
                        else {
                            this.vfePromiseLoading = false;
                            this.promptServerError({response},'Vfe.getNewEntry');
                        }
                    }
                })
                .catch(error=>{
                    this.vfePromiseLoading = false;
                    this.promptServerError(error,'Vfe.getNewEntry');
                });
            }
        },
        closeForm(form){
            if (this.selectedForm) {
                if (this.displayOption=='List') {
                    if (this.selectedVfe) {
                        /** for new entries */
                        if (!this.selectedVfe.vcardFormEntryId) {
                            if (this.hasChangesNewEntry) {
                                // Prompt use if he wants to proceed closing the form
                                // Add action to 'Save then Close' or 'Continue Close'
                                this.$dialog.confirm({
                                    title: 'Confirmation',
                                    message: 'You have unsaved changes. Are you sure you want to close this form?',
                                    cancelText: 'Cancel',
                                    confirmText: 'Close Form',
                                    type: 'is-warning',
                                    onConfirm: () => {
                                        this.selectedVfe = null;
                                        this.selectedForm = null;
                                        // Reset display option
                                        this.displayOption = "";
                                    }
                                })
                                return false;
                            }
                            let changedFields = this.getListChangedFields(this.selectedVfe);
                            if (changedFields.length == 0) {
                                /** If there are no changes */
                                this.selectedVfe = null;
                                this.selectedForm = null;
                                // Reset display option
                                this.displayOption = "";
                            }
                            else {
                                // Prompt use if he wants to proceed closing the form
                                // Add action to 'Save then Close' or 'Continue Close'
                                this.$dialog.confirm({
                                    title: 'Confirmation',
                                    message: 'You have unsaved changes. Are you sure you want to close this form?',
                                    cancelText: 'Cancel',
                                    confirmText: 'Close Form',
                                    type: 'is-warning',
                                    onConfirm: () => {
                                        this.selectedVfe = null;
                                        this.selectedForm = null;
                                        // Reset display option
                                        this.displayOption = "";
                                    }
                                })
                                return false;
                            }
                        }
                        else {
                            if (this.hasChangesNewEntry==true) {
                                // Prompt use if he wants to proceed closing the form
                                // Add action to 'Save then Close' or 'Continue Close'
                                this.$dialog.confirm({
                                    title: 'Confirmation',
                                    message: 'You have unsaved changes. Are you sure you want to close this form?',
                                    cancelText: 'Cancel',
                                    confirmText: 'Close Form',
                                    type: 'is-warning',
                                    onConfirm: () => {
                                        this.selectedVfe = null;
                                        this.selectedForm = null;
                                        // Reset display option
                                        this.displayOption = "";
                                    }
                                })
                                return false;
                            }
                            /** for existing entries */
                            if (this.selectedVfe.changedFields) {
                                if (this.selectedVfe.changedFields.length > 0) {
                                    // Prompt use if he wants to proceed closing the form
                                    // Add action to 'Save then Close' or 'Continue Close'
                                    this.$dialog.confirm({
                                        title: 'Confirmation',
                                        message: 'You have unsaved changes. Are you sure you want to close this form?',
                                        cancelText: 'Cancel',
                                        confirmText: 'Close Form',
                                        type: 'is-warning',
                                        onConfirm: () => {
                                            this.selectedVfe = null;
                                            this.selectedForm = null;
                                            // Reset display option
                                            this.displayOption = "";
                                        }
                                    })
                                    return false;
                                }
                                else {
                                    this.selectedVfe = null;
                                    this.selectedForm = null;
                                    // Reset display option
                                    this.displayOption = "";
                                }
                            }
                            else {
                                // New form entry
                                /*if (!this.isVfeValid) {
                                    this.$dialog.confirm({
                                        title: 'Confirmation',
                                        message: 'You might have unsaved changes. Are you sure you want to close this form?',
                                        cancelText: 'Cancel',
                                        confirmText: 'Close Form',
                                        type: 'is-warning',
                                        onConfirm: () => {
                                            this.selectedVfe = null;
                                            this.selectedForm = null;
                                            // Reset display option
                                            this.displayOption = "";
                                        }
                                    })
                                    return false;
                                }
                                else {*/
                                    this.selectedVfe = null;
                                    this.selectedForm = null;
                                    // Reset display option
                                    this.displayOption = "";
                                // }
                            }

                        }
                    }
                }
                else {
                    if (this.hasChangesVfeInTable) {
                        // Prompt use if he wants to proceed closing the form
                        // Add action to 'Save then Close' or 'Continue Close'
                        this.$dialog.confirm({
                            title: 'Confirmation',
                            message: 'You have unsaved changes. Are you sure you want to close this form?',
                            cancelText: 'Cancel',
                            confirmText: 'Close Form',
                            type: 'is-warning',
                            onConfirm: () => {
                                this.selectedForm = null;
                                // Reset display option
                                this.displayOption = "";
                            }
                        })
                        return false;
                    }
                    // If Table
                    // Check if for at least one vfe, there's change
                    this.selectedForm = null;
                }
                // Reset display option
                this.displayOption = "";
            }
            else {
            }
            this.showList = true;
        },
        getForms(queryParam){
            var reportingGroup = this.profile.reportingGroup;
            if (queryParam.repGroup) {
                reportingGroup = queryParam.repGroup;
            }
            var validationEntry = {
                reportingGroup : reportingGroup,
                reportingUnit : this.profile.reportingUnit,
                encoder : this.profile.name,
                logs : [],
                forms : []
            }
            if (this.allForms.length==0) {
                // Use form in constant data
                var allForms = FormsData.filter(form=>{
                    return ArrayUtil.inArray(form.reportingGroupAccess,reportingGroup)
                });
            }
            else {
                // Use form in store data
                var allForms = this.allForms.filter(form=>{
                    return ArrayUtil.inArray(form.reportingGroupAccess,reportingGroup)
                });
            }
            validationEntry.forms = allForms;
            this.setValidationEntry(validationEntry);
        },
        prepTableColumns(){
            // var selectedFormFields = this.selectedForm.formFields;
        },
        openForm(form){
            // this.activeFormEntry = null;
            // this.selectedForm = form;
            // this.prepTableColumns();
        },
        hasError (fieldId) {
            if (this.errorFields.length == 0) {
                return false
            }
            return ArrayUtil.inArray(this.errorFields,fieldId)
        },
        reqFieldValid (field) {
            var errorCount = 0;
            if (field && field.isRequired === true) {
                // ["dropdown", "textfield", "textarea", "number", "yes or no", "checkbox", "radio"]
                // ["string", "integer"]
                try {
                    if (field.inputType=='checkbox') {
                        if (field.fieldAnswerValue.length == 0) {
                            errorCount++;
                        }
                    }
                    else if (field.dataType=='string') {
                        if (field.fieldAnswerValue+''.trim().length==0) {
                            errorCount++;
                        }
                    }
                    else if (field.inputType=='decimal') {
                        if (field.fieldAnswerValue==='' || field.fieldAnswerLabel===null) {
                            errorCount ++;
                        }
                    }
                    else if (field.inputType=='number' && field.dataType=='integer') {
                        if (field.fieldAnswerValue==='') {
                            errorCount++;
                        }
                        else if (field.fieldAnswerValue===null) {
                            errorCount++;
                        }
                    }
                    else {
                        if (field.fieldAnswerValue=='' || field.fieldAnswerValue==null) {
                            errorCount ++;
                        }
                    }
                }
                catch(fieldError) {
                    console.log(fieldError)
                    console.log(field)
                }
            }
            if (errorCount == 0) {
                return true 
            }
            return false
        },
        clearFieldError (field) {
            if (field) {
                if (this.reqFieldValid(field)) {
                    return true
                }
            }
            return false
        },
        saveForm(){
            var errorCount = 0
            this.errorFields = []
            if (this.selectedVfe) {
                this.selectedVfe.formFields.forEach(field=>{
                    if (this.reqFieldValid(field)==false) {
                        errorCount ++;
                        this.errorFields.push(field.fieldId)
                    }
                })
            }

            if (errorCount > 0) {
                this.$dialog.alert({
                    title: 'Unable to save',
                    message: 'Some mandatory fields are not yet filled out. Please check.',
                    type: 'is-danger'
                });
                return false 
            }

            /** This is called if the displayOption is 'List' */
            // if ( (this.selectedVfe && !this.selectedVfe.changedFields && !this.isVfeValid) || 
            //      (this.selectedVfe && this.selectedVfe.changedFields && !this.hasChangedFields) ) {
            //     return false;
            // }

            /* Check if this is a new entry (for multiple entries) form */
            if (this.selectedVfe.vcardFormEntryId==undefined) {
                this.addNewVfe();
                return false;
            }
            else {
                /* 
                    Otherwise, for existing entry, update these properties:
                    - dateLastUpdated 
                    - lastUpdatedBy 
                */ 
                this.updateVfe(this.selectedVfe.vcardFormEntryId);

                /* Validate field answers */ 
                this.validateVfeAnswers(this.selectedVfe.vcardFormEntryId);
            }

        },
        isNewFormEntry(vfe){
            if (vfe) {
                if (vfe.formFields && vfe.formFields.length > 0) {
                    let fieldWithAns = vfe.formFields.filter(f=>{
                        return f.answers.length > 0
                    });
                    if (fieldWithAns.length > 0) {
                        return false;
                    }
                }
            }
            return true;
        },
        addNewVfe(vfe,fromSaveAll,isLastItem){
            let newVfeArr = {};
            if (!vfe) {
                // If add from List view
                newVfeArr = {
                    validationCardIdFk : this.selectedValidationCard.validationCardId,
                    accessIdFk : this.selectedVfe.accessIdFk,
                    reportingYear : this.selectedVfe.reportingYear,
                    generatedBy : this.profile.userId
                };
            }
            else {
                // If add/save from 'Table' view
                newVfeArr = {
                    validationCardIdFk : this.selectedValidationCard.validationCardId,
                    accessIdFk : vfe.accessIdFk,
                    reportingYear : vfe.reportingYear,
                    generatedBy : this.profile.userId
                };
            }

            /* Add new VFE to DB */
            VfeApi.addOne(newVfeArr)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error &&
                        response.data.vcardFormEntryId) {
                        /* To refresh the list at the left */
                        this.getValidationCard('newVfe',response.data.vcardFormEntryId,'fromAddOne');
                        /* Add field answers to this VFE using returned 'vcardFormEntryId' */ 
                        this.validateVfeAnswers(response.data.vcardFormEntryId,vfe,fromSaveAll,isLastItem);
                        
                        /** Upload file when VFE is created */
                        if (this.selectedForm.filesEnabled) {
                            if (this.displayOption == 'Table') {
                                this.uploadFilesTable(response.data.vcardFormEntryId,vfe)
                            }
                            else {
                                this.uploadFiles(response.data.vcardFormEntryId);
                            }
                        }

                        /** Log adding new vfe */
                        this.logActivity({
                            validationCardIdFk : newVfeArr.validationCardIdFk,
                            vfeIdFk : response.data.vcardFormEntryId,
                            activityByUser : this.profile.userId,
                            activitySection : VFE_SECTION_LOG,
                            activityMessageLog : "Submitted new form entry.",
                            activityBody : null
                        });
                    }
                    else {
                        this.promptServerError({response},'Vfe.addOne');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Vfe.addOne');
            });
        },
        updateVfe(vfeId,vfeData,fromSaveAll,isLastItem){
			if (this.selectedForm.filesEnabled) {
                if (this.displayOption == 'Table') {
                    this.uploadFilesTable(vfeId,vfeData)
                }
                else {
                    this.uploadFiles(vfeId,vfeData);
                }
            }

            /* Save 'lastUpdated' details to DB */
            VfeApi.update({
                vcardFormEntryId : vfeId,
                updatedBy : this.profile.userId
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        let updatedVfeData = {};
                        if (response.data.length > 0) {
                            updatedVfeData = response.data[0];
                        }

                        /** 
                         * Logic to log submission activity of
                         * first form entry
                         */
                        let isFreshEntry = null;
                        let useVcardId = null;
                        let useVfeId = null;

                        /** Log activity */ 
                        if (!vfeData) {
                            // From List
                            isFreshEntry = this.isNewFormEntry(this.selectedVfe);
                            useVcardId = this.selectedVfe.validationCardIdFk;
                            useVfeId = this.selectedVfe.vcardFormEntryId;
                        }
                        else {
                            // From Table
                            isFreshEntry = this.isNewFormEntry(vfeData);
                            useVcardId = vfeData.validationCardIdFk;
                            useVfeId = vfeData.vcardFormEntryId;
                        }

                        if (isFreshEntry==true) {
                            /** Log adding new vfe */
                            this.logActivity({
                                validationCardIdFk : useVcardId,
                                vfeIdFk : useVfeId,
                                activityByUser : this.profile.userId,
                                activitySection : VFE_SECTION_LOG,
                                activityMessageLog : "Submitted form entry.",
                                activityBody : null
                            });
                        }
                        
                        this.setVfeUpdatedByDetails(updatedVfeData,useVfeId);
                    }
                    else {
                        this.promptServerError({response},'Vfe.update');
                    }
                }
            })
            .catch(error=>{
                // Prompt for error
                this.promptServerError(error,'Vfe.update');
            });
        },
        setVfeUpdatedByDetails(updatedVfeData,vfeId){

            /* Change 'lastUpdatedByName' and 'dateLastUpdated' details on the page */
            if (this.vcardForms) {
                this.vcardForms.forEach(form=>{
                    if (this.selectedVfe) {
                        if (form.formIdFk==this.selectedVfe.formIdFk) {

                            if (form.vfe.length > 0) {

                                let currVfe = form.vfe.filter(vfe=>{
                                    return vfe.vcardFormEntryId == vfeId
                                });

                                /* To reflect new date last updated and last updated by name on the List at the left */ 
                                if (currVfe[0]) {
                                    // currVfe[0].dateLastUpdated = updatedVfeData.dateLastUpdated;
                                    currVfe[0].dateLastUpdated = AppResourceUtil.convertDate(updatedVfeData.dateLastUpdated)
                                    currVfe[0].lastUpdatedByName = updatedVfeData.lastUpdatedByName;
                                }

                                /* To reflect new date last updated and last updated by name on the Workspace panel */ 
                                if (this.selectedVfe) {
                                    // this.selectedVfe.dateLastUpdated = updatedVfeData.dateLastUpdated;
                                    this.selectedVfe.dateLastUpdated = AppResourceUtil.convertDate(updatedVfeData.dateLastUpdated)
                                    this.selectedVfe.lastUpdatedByName = updatedVfeData.lastUpdatedByName;
                                }

                            }
                        }
                    }
                })
            }
        },
        validateVfeAnswers(vfeId,vfe,fromSaveAll,isLastItem){
            /* Verify if there are new answers and changed existing answers */
            let newAnswers = [];
            let oldAnswers = [];

            if (!vfe && this.selectedVfe) {

                this.selectedVfe.formFields.forEach(field=>{
                    
                    let currField = {
                        vcardFormEntryId : vfeId,
                        fieldIdFk : field.fieldId,
                        answerDataType  : field.dataType,
                        answer : field.fieldAnswerValue,
                        answerDisplayString : field.fieldAnswerLabel,
                        generatedBy : this.profile.userId,
                        inputType : field.inputType,
                        optionType : field.optionType,
                        answerTextValue : null,
                        answerIntValue : null,
                        answerDecimalValue : null,
                        answerDateValue : null,
                        generatedBy : this.profile.userId
                    }; 

                    if (field.dataType=='string' && field.inputType!=='checkbox') {
                        currField.answerDisplayString = currField.answer.toString();
                        currField.answerTextValue = currField.answer.toString();
                    }

                    if (field.dataType=='date') {
                        // Set value/label to string
                        if (currField.answer) {
                            currField.answerDisplayString = this.$moment(currField.answer).format('YYYY-MM-DD');
                            currField.answerDateValue = currField.answerDisplayString;
                        }
                    }

                    if (currField.inputType=='decimal') {
                        currField.answerDecimalValue = parseFloat(currField.answer,10);
                    }

                    if (currField.inputType=='integer' || currField.inputType=='number') {
                        currField.answer = parseInt(currField.answer,10);
                        currField.answerDisplayString = currField.answer.toString();
                        currField.answerIntValue = parseInt(currField.answer,10);
                    }

                    if (currField.inputType=='dropdown' && field.optionType=='preset') {
                        if (field.options) {
                            if (field.options.length > 0) {
                                let opts = this.presetLovs[field.options[0].optionValue];

                                let selectedVal = opts.filter(opt=>{
                                    return opt.optionValue==field.fieldAnswerValue;
                                });

                                if (selectedVal.length > 0) {
                                    currField.answerDisplayString = selectedVal[0].optionLabel;
                                    currField.answerTextValue = currField.answer;
                                }
                            }
                        } 
                    }

                    if (field.inputType=='checkbox') {
                        if (currField.answer.length > 0) {                        
                            currField.answer.forEach(copt=>{
                                let currFieldCopy = Object.assign({},currField);
                                currFieldCopy.answerDisplayString = copt;
                                currFieldCopy.answerTextValue = copt;
                                if (field.answers.length > 0) {
                                    currFieldCopy.vfeFieldAnswerId = field.vfeFieldAnswerId;
                                    oldAnswers.push(currFieldCopy);
                                }
                                else {
                                    newAnswers.push(currFieldCopy);
                                }
                            })
                        }
                    }
                    else {

                        if (field.answers.length > 0) {
                            currField.vfeFieldAnswerId = field.vfeFieldAnswerId;
                            oldAnswers.push(currField)
                        }
                        else {
                            newAnswers.push(currField)
                        }

                    }
                
                });

            }
            else {
                vfe.formFields.forEach(field=>{
                    
                    let currField = {
                        vcardFormEntryId : vfeId,
                        fieldIdFk : field.fieldId,
                        answerDataType  : field.dataType,
                        answer : field.fieldAnswerValue,
                        answerDisplayString : field.fieldAnswerLabel,
                        generatedBy : this.profile.userId,
                        inputType : field.inputType,
                        optionType : field.optionType,
                        answerTextValue : null,
                        answerIntValue : null,
                        answerDecimalValue : null,
                        answerDateValue : null,
                        generatedBy : this.profile.userId
                    }; 

                    if (field.dataType=='string' && field.inputType!=='checkbox') {
                        currField.answerDisplayString = currField.answer.toString();
                        currField.answerTextValue = currField.answer.toString();
                    }

                    if (field.dataType=='date') {
                        // Set value/label to string
                        if (currField.answer) {
                            currField.answerDisplayString = this.$moment(currField.answer).format('YYYY-MM-DD');
                            currField.answerDateValue = currField.answerDisplayString;
                        }
                    }

                    if (currField.inputType=='decimal') {
                        currField.answerDecimalValue = parseFloat(currField.answer,10);
                    }

                    if (currField.inputType=='integer' || currField.inputType=='number') {
                        currField.answer = parseInt(currField.answer,10);
                        currField.answerDisplayString = currField.answer.toString();
                        currField.answerIntValue = parseInt(currField.answer,10);
                    }

                    if (currField.inputType=='dropdown' && field.optionType=='preset') {
                        if (field.options) {
                            if (field.options.length > 0) {
                                let opts = this.presetLovs[field.options[0].optionValue];

                                let selectedVal = opts.filter(opt=>{
                                    return opt.optionValue==field.fieldAnswerValue;
                                });

                                if (selectedVal.length > 0) {
                                    currField.answerDisplayString = selectedVal[0].optionLabel;
                                    currField.answerTextValue = currField.answer;
                                }
                            }
                        } 
                    }

                    if (field.inputType=='checkbox') {
                        if (currField.answer.length > 0) {                        
                            currField.answer.forEach(copt=>{
                                let currFieldCopy = Object.assign({},currField);
                                currFieldCopy.answerDisplayString = copt;
                                currFieldCopy.answerTextValue = copt;
                                if (field.answers.length > 0) {
                                    currFieldCopy.vfeFieldAnswerId = field.vfeFieldAnswerId;
                                    oldAnswers.push(currFieldCopy);
                                }
                                else {
                                    newAnswers.push(currFieldCopy);
                                }
                            })
                        }
                    }
                    else {

                        if (field.answers.length > 0) {
                            currField.vfeFieldAnswerId = field.vfeFieldAnswerId;
                            oldAnswers.push(currField)
                        }
                        else {
                            newAnswers.push(currField)
                        }

                    }
                
                });
            }
            
            if (newAnswers.length > 0) {
                this.addVfeAnswers(vfeId,newAnswers,vfe,fromSaveAll,isLastItem);
            }
            if (oldAnswers.length > 0) {
                this.updateVfeAnswers(vfeId,oldAnswers,vfe,fromSaveAll,isLastItem);
            }
        },
        addVfeAnswers(vfeId,fieldAnswers,vfe,fromSaveAll,isLastItem){
            VfeFieldAnswerApi.add(fieldAnswers)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isAdded) {
                            if (!fromSaveAll || (fromSaveAll && isLastItem==true)) {
                                this.$dialog.alert({
                                    title: 'Success',
                                    message: 'Form answers saved.',
                                    type: 'is-success'
                                });
                            }

                            // Get updated answers
                            try {
                                var useVfeData = null;
                                if (this.selectedVfe) {
                                    useVfeData = this.selectedVfe
                                }
                                else if (vfe) {
                                    useVfeData = vfe
                                }
                                if (useVfeData) {
                                    VfeApi.get(vfeId,useVfeData.formIdFk)
                                    .then(response=>{
                                        
                                        useVfeData.formFields = [];
                                        useVfeData.files = [];
                                        
                                        if (response.data) {
                                            if (!response.data.error) {
                                                if (response.data.fields) {
                                                    this.$set(useVfeData,'formFields',response.data.fields);
                                                    /* Parse date field to be consumed by the datepicker element */
                                                    if (useVfeData.formFields) {
                                                        useVfeData.formFields.forEach(field=>{
                                                            if (field.dataType=='string' && field.fieldAnswerValue==null) {
                                                                field.fieldAnswerValue = "";
                                                            }
                                                            if (field.dataType=='date') {
                                                                if (field.fieldAnswerValue!="" && field.fieldAnswerValue!=null) {
                                                                    field.fieldAnswerValue = new Date(field.fieldAnswerValue);
                                                                } else if (field.fieldAnswerLabel != '' && field.fieldAnswerLabel !==null) {
                                                                    field.fieldAnswerValue = new Date(field.fieldAnswerLabel);
                                                                } else {
                                                                    field.fieldAnswerValue = null
                                                                }
                                                            }
                                                        })
                                                    }
                                                }
                                                /* 
                                                If there are existing answers already, add 'changedFields' property
                                                for that form entry. This is where changed fields will be pushed.
                                                */ 
                                                if (response.data.hasAnswers) {
                                                    this.$set(useVfeData,'changedFields',[]);
                                                }
                                                /* If there are uploaded files for this entry*/ 
                                                if (response.data.files) {
                                                    // this.$set(useVfeData,'files',response.data.files);
                                                    let formEntryFiles = response.data.files;
                                                    formEntryFiles.forEach(f=>{
                                                        /** Convert data */
                                                        f.dateUploaded = AppResourceUtil.convertDate(f.dateUploaded)
                                                    })
                                                    this.$set(useVfeData,'files',formEntryFiles);
                                                }
                                            } 
                                            else {
                                                this.promptServerError({response},'Vfe.get');
                                            }
                                        }
                                        this.vfePromiseLoading = false;
                                    })
                                    .catch(error=>{
                                        this.vfePromiseLoading = false;
                                        this.promptServerError(error,'Vfe.get');
                                    });
                                }
                            }
                            catch(refreshErr){
                                console.log(refreshErr)
                            }
                            // End: Get updated answers
                        }
                        else {
                            this.$dialog.alert({
                                title: 'Error',
                                message: 'An error occurred. Please try again.',
                                type: 'is-danger'
                            });
                        }
                    }
                    else {
                        this.promptServerError({response},'VfeFieldAnswer.add');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'VfeFieldAnswer.add');
            })
        },
        updateVfeAnswers(vfeId,fieldAnswers,vfe,fromSaveAll,isLastItem){
            let changedAnswers = [];
            let changedAnswersLogs = [];

            if (!vfe && this.selectedVfe) {
                var changedFields = []
                if (this.selectedVfe.changedFields && this.selectedVfe.changedFields.length > 0) {
                    changedFields = this.selectedVfe.changedFields
                    /* this.selectedVfe.changedFields.forEach(field=>{
                        let ansVal = fieldAnswers.filter(ans=>{
                            return (ans.fieldIdFk==field.fieldId)
                        })
                        if (ansVal.length >0) {
                            ansVal.forEach(av=>{
                                changedAnswers.push(av);
                            })
                        }
                    })

                    if (changedAnswers.length > 0) {
                        // Build activity body for logging changed fields
                        changedAnswers.forEach(ans=>{
                            let fieldInfo = this.selectedVfe.changedFields.filter(fieldInfo=>{
                                return (ans.fieldIdFk==fieldInfo.fieldId)
                            });
                            if (fieldInfo.length > 0) {
                                if (fieldInfo[0]) {
                                    changedAnswersLogs.push({
                                        vfeFieldAnswerId : ans.vfeFieldAnswerId,
                                        fieldLabel : fieldInfo[0].fieldLabel,
                                        newValue : ans.answerDisplayString,
                                        oldValue : fieldInfo[0].originalFieldAnswerLabel.toString()
                                    });
                                }
                            }
                        });
                    } */
                }
                else {
                    changedFields = this.getListChangedFields(this.selectedVfe)
                }

                if (changedFields.length > 0) {
                    changedFields.forEach(field=>{
                        let ansVal = fieldAnswers.filter(ans=>{
                            return (ans.fieldIdFk==field.fieldId)
                        })
                        if (ansVal.length >0) {
                            ansVal.forEach(av=>{
                                changedAnswers.push(av);
                            })
                        }
                    })

                    if (changedAnswers.length > 0) {
                        // Build activity body for logging changed fields
                        changedAnswers.forEach(ans=>{
                            let fieldInfo = changedFields.filter(fieldInfo=>{
                                return (ans.fieldIdFk==fieldInfo.fieldId)
                            });
                            if (fieldInfo.length > 0) {
                                if (fieldInfo[0]) {
                                    var useLabel = fieldInfo[0].fieldLabel
                                    if (fieldInfo[0].fieldSubLabel) {
                                        useLabel += ` - ${fieldInfo[0].fieldSubLabel}`
                                    }
                                    changedAnswersLogs.push({
                                        vfeFieldAnswerId : ans.vfeFieldAnswerId,
                                        fieldLabel : useLabel,
                                        newValue : ans.answerDisplayString,
                                        oldValue : fieldInfo[0].originalFieldAnswerLabel.toString()
                                    });
                                }
                            }
                        });
                    }

                }
                
            }
            else {
                let changedFields = this.getTableVfeChangedFields(vfe);
                if (changedFields.length > 0) {
                    changedFields.forEach(field=>{
                        let ansVal = fieldAnswers.filter(ans=>{
                            return (ans.fieldIdFk==field.fieldId)
                        })
                        if (ansVal.length >0) {
                            ansVal.forEach(av=>{
                                changedAnswers.push(av);
                            });
                        }
                    })

                    if (changedAnswers.length > 0) {
                        // Build activity body for logging changed fields
                        changedAnswers.forEach(ans=>{
                            let fieldInfo = changedFields.filter(fieldInfo=>{
                                // vfe.changedFields
                                return (ans.fieldIdFk==fieldInfo.fieldId)
                            });
                            if (fieldInfo.length > 0) {
                                if (fieldInfo[0]) {
                                    var useLabel = fieldInfo[0].fieldLabel
                                    if (fieldInfo[0].fieldSubLabel) {
                                        useLabel += ` - ${fieldInfo[0].fieldSubLabel}`
                                    }
                                    changedAnswersLogs.push({
                                        vfeFieldAnswerId : ans.vfeFieldAnswerId,
                                        fieldLabel : useLabel,
                                        newValue : ans.answerDisplayString,
                                        oldValue : fieldInfo[0].originalFieldAnswerLabel.toString()
                                    });
                                }
                            }
                        });
                    }
                }
            }

            if (changedAnswers.length > 0) {

                VfeFieldAnswerApi.update(changedAnswers)
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {
                            if (response.data.isUpdated) {
                                if (!fromSaveAll || (fromSaveAll==true && isLastItem==true)) {
                                    this.$dialog.alert({
                                        title: 'Success',
                                        message: 'Form answers updated.',
                                        type: 'is-success'
                                    });
                                }
                                if (this.selectedForm) {
                                    // To refresh and refresh the changed fields after saving
                                    // this.refreshData(true);

                                    // Get updated answers
                                    try {
                                        var useVfeData = null;
                                        if (this.selectedVfe) {
                                            useVfeData = this.selectedVfe
                                        }
                                        else if (vfe) {
                                            useVfeData = vfe
                                        }
                                        if (useVfeData) {
                                            VfeApi.get(vfeId,useVfeData.formIdFk)
                                            .then(response=>{
                                                
                                                useVfeData.formFields = [];
                                                useVfeData.files = [];
                                                
                                                if (response.data) {
                                                    if (!response.data.error) {
                                                        if (response.data.fields) {
                                                            this.$set(useVfeData,'formFields',response.data.fields);
                                                            /* Parse date field to be consumed by the datepicker element */
                                                            if (useVfeData.formFields) {
                                                                useVfeData.formFields.forEach(field=>{
                                                                    if (field.dataType=='string' && field.fieldAnswerValue==null) {
                                                                        field.fieldAnswerValue = "";
                                                                    }
                                                                    if (field.dataType=='date') {
                                                                        if (field.fieldAnswerValue!="" && field.fieldAnswerValue!=null) {
                                                                            field.fieldAnswerValue = new Date(field.fieldAnswerValue);
                                                                        } else if (field.fieldAnswerLabel != '' && field.fieldAnswerLabel !==null) {
                                                                            field.fieldAnswerValue = new Date(field.fieldAnswerLabel);
                                                                        } else {
                                                                            field.fieldAnswerValue = null
                                                                        }
                                                                    }
                                                                })
                                                            }
                                                        }
                                                        /* 
                                                        If there are existing answers already, add 'changedFields' property
                                                        for that form entry. This is where changed fields will be pushed.
                                                        */ 
                                                        if (response.data.hasAnswers) {
                                                            this.$set(useVfeData,'changedFields',[]);
                                                        }
                                                        /* If there are uploaded files for this entry*/ 
                                                        if (response.data.files) {
                                                            // this.$set(useVfeData,'files',response.data.files);
                                                            let formEntryFiles = response.data.files;
                                                            formEntryFiles.forEach(f=>{
                                                                /** Convert data */
                                                                f.dateUploaded = AppResourceUtil.convertDate(f.dateUploaded)
                                                            })
                                                            this.$set(useVfeData,'files',formEntryFiles);
                                                        }
                                                    } 
                                                    else {
                                                        this.promptServerError({response},'Vfe.get');
                                                    }
                                                }
                                                this.vfePromiseLoading = false;
                                            })
                                            .catch(error=>{
                                                this.vfePromiseLoading = false;
                                                this.promptServerError(error,'Vfe.get');
                                            });
                                        }
                                    }
                                    catch(refreshErr){
                                        console.log(refreshErr)
                                    }
                                    // End: Get updated answers
                                }

                                let activityBody = "";
                                if (changedAnswersLogs.length > 0) {
                                    activityBody = JSON.stringify(changedAnswersLogs);
                                }

                                // Log activity
                                if (!vfe && this.selectedVfe) {
                                    this.logActivity({
                                        validationCardIdFk : this.selectedVfe.validationCardIdFk,
                                        vfeIdFk : this.selectedVfe.vcardFormEntryId,
                                        activityByUser : this.profile.userId,
                                        activitySection : VFE_SECTION_LOG,
                                        activityMessageLog : "Saved form entry. Changed fields.",
                                        activityBody
                                    });
                                }
                                else {
                                    this.logActivity({
                                        validationCardIdFk : vfe.validationCardIdFk,
                                        vfeIdFk : vfeId,
                                        activityByUser : this.profile.userId,
                                        activitySection : VFE_SECTION_LOG,
                                        activityMessageLog : "Saved form entry. Changed fields.",
                                        activityBody
                                    });
                                }
                            }
                            else {
                                this.$dialog.alert({
                                    title: 'Error',
                                    message: 'An error occurred on update. Please try again.',
                                    type: 'is-danger'
                                });
                            }
                        }
                        else {
                            this.promptServerError({response},'VfeFieldAnswer.update');
                        }
                    }
                })
                .catch(error=>{
                    this.promptServerError(error,'VfeFieldAnswer.update');
                })
            }
            else {
                if ( ( !this.selectedForm.filesEnabled) || 
                     ( this.displayOption=='List' && this.selectedForm.filesEnabled && this.dropFiles.length==0) ||
                     ( this.displayOption=='Table' && this.selectedForm.filesEnabled && (vfe && vfe.dropFiles && vfe.dropFiles.length == 0) ) 
                    ) {
                    // No changed fields
                    this.$dialog.alert({
                        title: 'Info',
                        message: 'No changes detected.',
                        type: 'is-info'
                    });
                }
            }
        },
        logActivity(logData){
            ActivityLogsApi.add(logData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error &&
                        response.data.logId) {
                        /** Success */
                    }
                    else {
                        this.promptServerError({response},'ActivityLogs.add');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ActivityLogs.add');
            });
        },
        onInput(event,fieldAns) {
            fieldAns.fieldAnswerValue = event.target._vCleave.getRawValue();
            fieldAns.fieldAnswerLabel = event.target._vCleave.getFormattedValue();
        },
        confirmDelete(){
            if (this.selectedForm) {
                if (this.selectedForm.displayOption=='List' && 
                    this.selectedForm.formSubmissionType=='Multiple' && 
                    this.selectedForm.vfe.length == 1) {
                    // For multiple submission type; list view forms
                    this.$dialog.alert({
                        title: 'Action not allowed',
                        type: "is-warning",
                        message: "This is the last form entry available under this form. Please maintain at least one entry for each multiple-submission type forms."
                    })
                    return false;
                }
            }
            this.$dialog.confirm({
                title: 'Delete Confirmation',
                message: 'This action cannot be undone. Are you sure you want to delete this form entry?',
                cancelText: 'Cancel',
                confirmText: 'Delete',
                type: 'is-danger',
                onConfirm: () => {
                    this.deleteVfe()
                }
            })
        },
        deleteVfe(){
            if (!this.selectedVfe.hasOwnProperty('vcardFormEntryId')) {
                return false;
            } 
            VfeApi.delete(this.selectedVfe.vcardFormEntryId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isDeleted) {
                            this.$dialog.alert({
                                title: 'Success',
                                message: 'Form entry deleted.',
                                type: 'is-success'
                            });

                            // Log delete VFE activity
                            this.logActivity({
                                validationCardIdFk : this.selectedVfe.validationCardIdFk,
                                vfeIdFk : null,
                                activityByUser : this.profile.userId,
                                activitySection : VCARD_SECTION_LOG,
                                activityMessageLog : `Deleted form entry under this form: ${this.selectedForm.formName}.`,
                                activityBody : null
                            });

                            // Remove selected vfe from workspace view
                            this.selectedForm = null;
                            this.selectedVfe = null;
                            /* To refresh the list at the left */
                            this.getValidationCard('start',null);
                            return false;
                        }
                        else {
                            this.$dialog.alert({
                                title: 'Error',
                                message: 'An error occurred on delete. Please try again later.',
                                type: 'is-danger'
                            });
                            return false;
                        }
                    }
                    else {
                        this.promptServerError({response},'Vfe.delete');
                        return false;
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Vfe.delete');
                return false;
            })
        },
        refreshData(triggeredFromSave){
            if (!triggeredFromSave) {
                if (this.unsavedChanges()) {
                    this.$dialog.confirm({
                        title: "You have unsaved changes",
                        message: "Refresh might lose your unsaved change. To continue with data entry, click 'Continue editing'. Othewise, click 'Discard Changes'.",
                        cancelText: "Discard Changes",
                        confirmText: "Continue editing",
                        type: 'is-warning',
                        onConfirm: () => {
                            // stay
                        },
                        onCancel: ()=>{
                            // Add check for unsave changes
                            if (this.selectedValidationCardId!=null) {
                                this.getValidationCard('start');
                            }
                        }
                    });
                    return false
                }
            }
            // Add check for unsave changes
            if (this.selectedValidationCardId!=null) {
                this.getValidationCard('start');
            }
        },
        openFormTable(form,newDisplayOption,trigger){
            if (form.displayOption=='Table' || 
                (newDisplayOption && newDisplayOption=='Table')) {
                
                this.vfePromiseLoading = true;

                FormsApi.getOne(form.formIdFk)
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {
                            this.selectedForm = form;
                            this.selectedForm.formFields = response.data.formFields;
                            this.getFormVfes(this.selectedForm,newDisplayOption);
                        }
                        else {
                            this.promptServerError({response},'Form.getOne');
                        }
                    }
                    this.vfePromiseLoading = false;
                })
                .catch(error=>{
                    this.vfePromiseLoading = false;
                    this.promptServerError(error,'Form.getOne');
                });
            }
        },
        getFormVfes(selectedForm,newDisplayOption){
            
            if (this.selectedForm.vfe.length > 0) {
               
                // Get existing answers for each VFE field
                this.selectedForm.vfe.forEach(vfe=>{

                    this.vfePromiseLoading = true;

                    if (vfe.hasOwnProperty('vcardFormEntryId')) {
                        VfeApi.get(vfe.vcardFormEntryId,vfe.formIdFk)
                        .then(response=>{

                            this.$set(vfe,'formFields',[]);
                            this.$set(vfe,'files',[]);
                            this.$set(vfe,'dropFiles',[])
                            this.$set(vfe,'fileUploadError',false)
                            this.$set(vfe,'fileUploadErroMsg','')
                            try {
                                if (response.data) {
                                    if (!response.data.error) {
                                        if (response.data.fields) {
                                            
                                            // let currFormFields = response.data.fields;
                                            this.$set(vfe,'formFields',response.data.fields);
                                            /* Parse date field to be consumed by the datepicker element */
                                            if (vfe.formFields.length > 0) {
                                                vfe.formFields.forEach(currField=>{
                                                    if (currField.dataType=='string' && currField.fieldAnswerValue==null) {
                                                        currField.fieldAnswerValue = "";
                                                    }
                                                    if (currField.dataType=='date') {
                                                        if (currField.fieldAnswerValue!="" && currField.fieldAnswerValue!=null) {
                                                            currField.fieldAnswerValue = new Date(currField.fieldAnswerValue);
                                                        }  else if (currField.fieldAnswerLabel != '' && currField.fieldAnswerLabel !==null) {
                                                            currField.fieldAnswerValue = new Date(currField.fieldAnswerLabel);
                                                        } else {
                                                            currField.fieldAnswerValue = null
                                                        }
                                                    }
                                                });
                                            }

                                        }
                                        /* 
                                        If there are existing answers already, add 'changedFields' property
                                        for that form entry. This is where changed fields will be pushed.
                                        */ 
                                        if (response.data.hasOwnProperty('hasAnswers')) {
                                            vfe.changedFields = [];
                                        }
                                        /* If there are uploaded files for this entry*/ 
                                        if (response.data.files) {
                                            // this.$set(vfe,'files',response.data.files);
                                            let formEntryFiles = response.data.files;
                                            formEntryFiles.forEach(f=>{
                                                /** Convert data */
                                                f.dateUploaded = AppResourceUtil.convertDate(f.dateUploaded)
                                            })
                                            this.$set(vfe,'files',formEntryFiles);
                                        }
                                        /* If called from changeDisplay() */ 
                                        if (newDisplayOption) {
                                            this.displayOption = newDisplayOption;
                                        }
                                        else {
                                            /** Default display setting if not coming form changeDisplay() */ 
                                            this.displayOption = selectedForm.displayOption;
                                        }
                                    }
                                    else {
                                        this.promptServerError({response},'Vfe.get');
                                    }
                                }
                            }
                            catch(getVfeErr) {
                                console.log(getVfeErr)
                            }
                            this.vfePromiseLoading = false;
                        })
                        .catch(error=>{
                            this.vfePromiseLoading = false;
                            this.promptServerError(error,'Vfe.get');
                        });
                    }
                });
                
                
            }
            else {
                this.vfePromiseLoading = false;
            }
        },
        addFormTableEntry(trigger){
            // Called if displayOption is 'Table' only
            // trigger is from 'workspace' or 'list'
            if (trigger) {   
                // For table view behavior for adding new entry
                // For list display behavior
                let useRepYear = this.selectedReportingYear;
                if (this.selectedForm) {
                    useRepYear = this.selectedForm.reportingYear;
                }
                if (!useRepYear) {
                    if (this.selectedForm.vfe.length > 0) {
                        useRepYear = this.selectedForm.vfe[this.selectedForm.vfe.length-1].reportingYear;
                    }
                }

                this.vfePromiseLoading = true;
                
                VfeApi.getNewEntry(this.selectedForm.formIdFk)
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {
                            let newVfe = {};
                            this.$set(newVfe,'accessIdFk',this.selectedForm.accessIdFk);
                            this.$set(newVfe,'reportingYear',useRepYear);
                            this.$set(newVfe,'formIdFk',this.selectedForm.formIdFk);
                            this.$set(newVfe,'formName',this.selectedForm.formName);
                            this.$set(newVfe,'formSubmissionType',this.selectedForm.formSubmissionType);
                            this.$set(newVfe,'displayOption',this.selectedForm.displayOption);
                            this.$set(newVfe,'sequenceNumber',this.selectedForm.sequenceNumber);
                            this.$set(newVfe,'formFields',response.data);
                            this.$set(newVfe,'files',[]);
                            this.$set(newVfe,'dropFiles',[]);
                            this.$set(newVfe,'fileUploadError',false)
                            this.$set(newVfe,'fileUploadErroMsg',false)

                            this.selectedForm.vfe.push(newVfe);
                            this.vfePromiseLoading = false;
                        }
                        else {
                            this.vfePromiseLoading = false;
                            this.promptServerError({response},'Vfe.getNewEntry');
                        }
                    }
                })
                .catch(error=>{
                    this.vfePromiseLoading = false;
                    this.promptServerError(error,'Vfe.getNewEntry');
                });
            }
        },
        confirmDeleteTableVfe(vfe,vfeIdx){
            if (this.selectedForm) {
                if (this.selectedForm.vfe.length == 1) {
                    // For multiple submission type; list view forms
                    this.$dialog.alert({
                        title: 'Action not allowed',
                        type: "is-warning",
                        message: "This is the last form entry available under this form. Please maintain at least one entry for each of the forms."
                    })
                    return false;
                }
            }
            
            this.$dialog.confirm({
                title: 'Delete Confirmation',
                message: 'This action cannot be undone. Are you sure you want to delete this form entry?',
                cancelText: "Cancel",
                confirmText: 'Delete',
                type: 'is-danger',
                onConfirm: () => {
                    this.doDeleteVfe(vfe,vfeIdx);
                }
            })
        },
        doDeleteVfe(vfe,vfeIdx){
            if (!vfe.hasOwnProperty('vcardFormEntryId')) {
                // Delete from the table
                if (this.selectedForm.vfe.length > 0) {
                    this.selectedForm.vfe.splice(vfeIdx,1);
                }
                return false;
            } 

            VfeApi.delete(vfe.vcardFormEntryId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isDeleted) {
                            this.$dialog.alert({
                                title: 'Success',
                                message: 'Form entry deleted.',
                                type: 'is-success'
                            });
                            // Log delete VFE activity
                            this.logActivity({
                                validationCardIdFk : vfe.validationCardIdFk,
                                vfeIdFk : null,
                                activityByUser : this.profile.userId,
                                activitySection : VCARD_SECTION_LOG,
                                activityMessageLog : `Deleted form entry under this form: ${this.selectedForm.formName}.`,
                                activityBody : null
                            });
                            this.selectedForm = null;
                            this.selectedVfe = null;
                            /* To refresh the list at the left */
                            this.getValidationCard('start',null);
                            return false;
                        }
                        else {
                            this.$dialog.alert({
                                title: 'Error',
                                message: 'An error occurred on delete. Please try again later.',
                                type: 'is-danger'
                            });
                            return false;
                        }
                    }
                    else {
                        this.promptServerError({response},'Vfe.delete');
                        return false;
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Vfe.delete');
                return false;
            })
        },
        isTableVfeValid(vfe){
            let errorCount = 0;
            if (vfe) {
                if (vfe.formFields) {
                    if (vfe.formFields.length > 0) {
                        vfe.formFields.forEach(field=>{
                            if (field.inputType=='checkbox') {
                                if (field.isRequired && field.fieldAnswerValue.length == 0) {
                                    errorCount ++;
                                }
                            }
                            else if (field.dataType=='string') {
                                if (field.isRequired && field.fieldAnswerValue.trim().length==0) {
                                    errorCount ++;
                                }
                            }
                            else if (field.inputType=='decimal') {
                                if (field.isRequired && (field.fieldAnswerValue=='' || field.fieldAnswerLabel==null)) {
                                    errorCount ++;
                                }
                            }
                            else {
                                if (field.isRequired && (field.fieldAnswerValue=='' || field.fieldAnswerValue==null) ) {
                                    errorCount ++;
                                }
                            }
                        })
                    }
                }
            }
            if (errorCount > 0) {
                return false
            }
            return true
        },
        hasTableVfeChangedFields(vfe){
            if (vfe) {
                if (!vfe.changedFields) {
                    return false
                }
                
                let changedFields = []; // vfe.changedFields = [];
                if (vfe.formFields.length > 0) {
                    vfe.formFields.forEach(field=>{
                        if (field.dataType!=='date') {
                            if (field.inputType!=='checkbox') {
                                if (field.fieldAnswerValue!==field.originalFieldAnswerValue) {
                                    changedFields.push(field); //vfe.changedFields.push(field)
                                }
                            }
                            else {
                                if (JSON.stringify(field.fieldAnswerValue)!=JSON.stringify(field.originalFieldAnswerValue)) {
                                    changedFields.push(field); // vfe.changedFields.push(field)
                                }
                            }
                        }
                        else {
                            if ( this.$moment(field.fieldAnswerValue).format('YYYY-MM-DD')!= field.originalFieldAnswerValue ) {
                                changedFields.push(field); //vfe.changedFields.push(field);
                            }
                        }
                    })
                }

                if (changedFields.length > 0) { // (vfe.changedFields.length > 0)
                    return true;
                }

                if (this.dropFiles.length > 0) {
                    return true;
                }
            }
            return false;
        },
        getTableVfeChangedFields(vfe){
            if (vfe) {
                if (!vfe.changedFields) {
                    return [];
                }                
                let changedFields = []; 
                if (vfe.formFields.length > 0) {
                    vfe.formFields.forEach(field=>{
                        if (field.dataType!=='date') {
                            if (field.inputType!=='checkbox') {
                                if (field.fieldAnswerValue!==field.originalFieldAnswerValue) {
                                    changedFields.push(field);
                                }
                            }
                            else {
                                if (JSON.stringify(field.fieldAnswerValue)!=JSON.stringify(field.originalFieldAnswerValue)) {
                                    changedFields.push(field);
                                }
                            }
                        }
                        else { 
                            if ( this.$moment(field.fieldAnswerValue).format('YYYY-MM-DD')!= field.originalFieldAnswerValue ) {
                                changedFields.push(field);
                            }
                        }
                    })
                }

                if (changedFields.length > 0) {
                    return changedFields;
                }
            }
            return [];
        },
        getListChangedFields(vfe){
            if (vfe) {
                if (!vfe.vcardFormEntryId) {      
                    let changedFields = []; 
                    if (vfe.formFields.length > 0) {
                        vfe.formFields.forEach(field=>{
                            if (field.dataType!=='date') {
                                if (field.inputType!=='checkbox') {
                                    if (field.fieldAnswerValue!==field.originalFieldAnswerValue) {
                                        changedFields.push(field);
                                    }
                                }
                                else {
                                    if (JSON.stringify(field.fieldAnswerValue)!=JSON.stringify(field.originalFieldAnswerValue)) {
                                        changedFields.push(field);
                                    }
                                }
                            }
                            else { 
                                if ( this.$moment(field.fieldAnswerValue).format('YYYY-MM-DD')!= field.originalFieldAnswerValue ) {
                                    changedFields.push(field);
                                }
                            }
                        })
                    }

                    if (changedFields.length > 0) {
                        return changedFields;
                    }
                }
                else {
                    let changedFields = []; 
                    if (vfe.formFields.length > 0) {
                        vfe.formFields.forEach(field=>{
                            if (field.dataType!=='date') {
                                if (field.inputType!=='checkbox') {
                                    if (field.fieldAnswerValue!==field.originalFieldAnswerValue) {
                                        changedFields.push(field);
                                    }
                                }
                                else {
                                    if (JSON.stringify(field.fieldAnswerValue)!=JSON.stringify(field.originalFieldAnswerValue)) {
                                        changedFields.push(field);
                                    }
                                }
                            }
                            else { 
                                if ( this.$moment(field.fieldAnswerValue).format('YYYY-MM-DD')!= field.originalFieldAnswerValue ) {
                                    changedFields.push(field);
                                }
                            }
                        })
                    }

                    if (changedFields.length > 0) {
                        return changedFields;
                    }
                }
            }
            return [];
        },
        saveVfe(vfe,vfeIdx,fromSaveAll,isLastItem){
            var errorCount = 0
            var reqFields = []
            this.errorFields = []
            if (vfe) {
                vfe.formFields.forEach(field=>{
                    if (this.reqFieldValid(field)==false) {
                        errorCount ++;
                        this.errorFields.push(field.fieldId)
                    }
                })
            }
            if (errorCount > 0) {
                this.$dialog.alert({
                    title: 'Unable to save',
                    message: 'Some mandatory fields are not yet filled out. Please check.',
                    type: 'is-danger'
                });
                return false 
            }

            /** This is called if displayOption is 'Table' */

            /* Check if this is a new entry (for multiple entries) form */
            if (vfe.vcardFormEntryId==undefined) {
                this.addNewVfe(vfe,fromSaveAll,isLastItem)
                return false;
            }
            else {
                /* 
                    Otherwise, for existing entry, update these properties:
                    - dateLastUpdated 
                    - lastUpdatedBy 
                */ 
                this.updateVfe(vfe.vcardFormEntryId,vfe);
                /* Validate field answers */ 
                this.validateVfeAnswers(vfe.vcardFormEntryId,vfe);
            }
        },
        checkFile(){
            this.fileUploadError = false;
			this.fileUploadErroMsg = "";
			
            if (this.dropFiles.length > 0) {
                if (this.dropFiles[this.dropFiles.length-1]) {

                    let currFile = this.dropFiles[this.dropFiles.length-1];
                    let fileType = currFile.type;
                    let fileName = currFile.name;
                    let tempFileName = fileName.split('.');
                    let fileExt = tempFileName[tempFileName.length-1];

                    /* Check if file type is valid */ 
                    if (ArrayUtil.inArray(FileTypes,fileType)==false && 
                        ArrayUtil.inArray(FileTypes,fileExt)==false) {

                        /* INVALID FILE TYPE*/

                        // Remove last selected file with invalid type
                        this.dropFiles.splice(this.dropFiles.length-1,1);
                        this.fileUploadError = true;
                        this.fileUploadErroMsg = "Error: Unable to add file. Invalid file type detected.";
                        return false;
					}

                    /* 
                        Check if file size is allowed 
                        - Post request total should not be more than 100MB
                        - Number of files per request should not be more than 20
                        and total file size should not be more than 100MB
                        
                        500 000 bytes or 500KB for pictures
                    */ 
				   
				   	/* If file exceeds maximum file size limit */ 
                    if (currFile.size > MAX_FILESIZE_TOTAL ) {
						this.dropFiles.splice(this.dropFiles.length-1,1);
						this.fileUploadError = true;
						this.fileUploadErroMsg = "Error: Unable to add file. File is too large. You can upload files with size not greater than 100MB.";
						return false;
					}
					
					/* If total number of files is more than the limit (20)*/ 
				   	if (this.dropFiles.length > 20) {
						this.dropFiles.splice(this.dropFiles.length-1,1);
						this.fileUploadError = true;
						this.fileUploadErroMsg = "Error: Unable to add file. Maximum number of files is reached. Only 20 files are allowed per transaction.";
						return false;
					}
					
					/** 
					 * Compute total file size
					 * and check if it's less than the limit
					 * */ 
                    let totalFileSize = this.dropFiles.reduce((prev,f)=>{
						return prev + f.size;
					},0);

					if (totalFileSize > MAX_FILESIZE_TOTAL) {
						this.dropFiles.splice(this.dropFiles.length-1,1);
						this.fileUploadError = true;
						this.fileUploadErroMsg = "Error: Unable to add file. Maximum file size is reached. Only up to 100MB is allowed per transaction.";
						return false;
					}
                }
            }
        },
        deleteDropFile(index) {
            this.dropFiles.splice(index, 1)
		},
		uploadFiles(vfeId,vfeData){
            /** 
             * vfeId can come from newly-created vfe or from 
             * saveVfe function from Table view;
             * vfeData - selected vfe from Table view
             * */ 
            
            let logData = {
                validationCardIdFk : null,
                vfeIdFk : vfeId,
                activityByUser : this.profile.userId,
                activitySection : VFE_SECTION_LOG,
                activityMessageLog : "Uploaded supporting document/file.",
                activityBody : ''
            };

            let formData = new FormData();

			if (this.dropFiles.length > 0) {

                let fileNames = [];

				this.dropFiles.forEach((file,i)=>{
                    // Get filenames for logs
                    fileNames.push(file.name);
                    // Add each file to formData
                    formData.append('files['+i+']', file);
                });

                logData.activityBody = fileNames.join(", ");
                
                formData.append('uploadedBy',this.profile.userId);
                formData.append('reportingYear',this.selectedReportingYear);
                formData.append('vfeId',vfeId);

                if (this.displayOption=='List') {
                    if (this.selectedVfe) {
                        formData.append('vcardIdFk',this.selectedVfe.validationCardIdFk);
                        logData.validationCardIdFk = this.selectedVfe.validationCardIdFk;
                    }
                }
                else {
                    if (vfeData) {
                        formData.append('vcardIdFk',vfeData.validationCardIdFk);   
                        logData.validationCardIdFk = vfeData.validationCardIdFk;
                    }
                }                

                if (logData.validationCardIdFk === undefined) {
                    this.$dialog.alert({
                        title: 'Error',
                        message: 'Unable to proceed. Validation Card Id is missing. Please refresh the page and try again.',
                        type: 'is-danger'
                    });
                    return false
                }

                this.showLoading()
                FilesApi.addToVfe(formData)
                .then(response=>{
                    this.closeLoading()
                    if (response.data) {
                        if (!response.data.error) {
                            if (response.data.success==true) {

                                // Log file upload activity
                                this.logActivity(logData);
                                
                                this.$notification.open({
                                    duration: 5000,
                                    message: 'Files uploaded successfully.',
                                    position: 'is-bottom-left',
                                    type: 'is-success'
                                });

                                // Reset upload form
                                this.dropFiles = [];

                                // Refresh data
                                this.refreshFiles(vfeId);                            
                                return false;
                            }
                            else {
                                this.$notification.open({
                                    duration: 5000,
                                    message: 'A problem occurred while uploading files. Please try again.',
                                    position: 'is-bottom-left',
                                    type: 'is-danger'
                                });
                                return false;
                            }
                        }
                        else {
                            this.promptServerError({response},'File.addToVfe');
                            return false;
                        }
                    }
                })
                .catch(error=>{
                    this.closeLoading()
                    this.promptServerError(error,'File.addToVfe');
                    return false;
                });

			}			
  
        },
        refreshFiles(vfeId){
            let vfeData = null;
            if (this.displayOption=='List') {
                if (this.selectedVfe) {
                    this.$set(this.selectedVfe,'files',[]);
                }
            }
            
            FilesApi.getVfeFiles(vfeId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length > 0) {
                            if (this.displayOption=='List') {
                                this.$set(this.selectedVfe,'files',response.data);
                            }
                            else {
                                if (this.selectedForm) {
                                    if (this.selectedForm.vfe) {
                                        this.selectedForm.vfe.forEach(vcfe=>{
                                            if (vcfe.vcardFormEntryId==vfeId) {
                                                this.$set(vcfe,'files',response.data);
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                    else {
                        this.promptServerError({response},'File.get');
                    }
                }
            })
            .catch(error=>{ 
                this.promptServerError(error,'File.get');
            });
        },
        openFile(file){
            if (file.vfeFilePath) {
                let t = file.vfeFilePath.split('../');
                if (t[1]) {
                    window.open(this.baseUrl+t[1]);
                }
            }
        },
        confirmDeleteFile(file,fileIdx){
            this.$dialog.confirm({
                title: 'Confirm delete',
                message: 'This action will delete '+file.vfeFileTitle+' permanently. Are you sure you want to delete this file?',
                cancelText: "Don't Delete",
                confirmText: 'Delete File',
                type: 'is-danger',
                onConfirm: () => {
                    // Delete file
                    this.deleteFile(file,fileIdx);
                }
            })
        },
        deleteFile(file,fileIdx) {

            let logData = {
                validationCardIdFk : null,
                vfeIdFk : null,
                activityByUser : this.profile.userId,
                activitySection : VFE_SECTION_LOG,
                activityMessageLog : "Deleted supporting document/file.",
                activityBody : file.vfeFileTitle
            };

            FilesApi.delete(file)
			.then(response=>{
				if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isDeleted) {                        
                            if (this.displayOption=='List') {
                                // Log delete file activity.
                                logData.validationCardIdFk = this.selectedVfe.validationCardIdFk;
                                logData.vfeIdFk = this.selectedVfe.vcardFormEntryId;
                                                            
                                // Remove from UI
                                this.selectedVfe.files.splice(fileIdx,1);

                                this.$notification.open({
                                    duration: 5000,
                                    message: 'File removed successfully.',
                                    position: 'is-bottom-left',
                                    type: 'is-success'
                                });                          
                            }
                            else {
                                // Log delete file activity.
                                logData.validationCardIdFk = this.openedVfe.validationCardIdFk;
                                logData.vfeIdFk = this.openedVfe.vcardFormEntryId;

                                // Remove from UI
                                this.openedVfe.files.splice(fileIdx,1);
                            }  

                            // Log delete file activity
                            this.logActivity(logData);                        
                            return false;
                        }
                        else {
                            this.$notification.open({
                                duration: 5000,
                                message: 'A problem occurred while deleting the file. Please try again.',
                                position: 'is-bottom-left',
                                type: 'is-danger'
                            });
                            return false;
                        }
                    }
                    else {
                        this.promptServerError({response},'File.delete');
                        return false;
                    }
                }
			})
			.catch(error=>{
                this.promptServerError(error,'File.delete');
                return false;
			})
        },
        showVfeFiles(vfe){
            this.openVfeFilesDialog = true;
            this.openedVfe = vfe;
        },
        closeVfeFilesDialog(){
            this.openVfeFilesDialog = false;
            this.openedVfe = null;
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        preventLeave(event){
            if (this.displayOption=='List') {
                if (this.hasChangedFields==false && this.hasChangesNewEntry==false) {
                    return;
                }
            }
            else if (this.displayOption=='Table') {
                if (this.hasChangesVfeInTable==false) {
                    return;
                }
            }
			event.preventDefault()
			event.returnValue = "";
        },
        unsavedChanges(){
            if (this.displayOption=='List') {
                if (this.hasChangedFields || this.hasChangesNewEntry) {
                    return true;
                }
            }
            else if (this.displayOption=='Table'){
                if (this.hasChangesVfeInTable) {
                    return true;
                }
            }
            return false;
        },
        setFieldLabel(field) {
            let label = field.fieldLabel //+' ('+fieldeldSubLabel+')'
            if (field.fieldSubLabel) {
                // label += ` (${field.fieldSubLabel})`
            }
            if (field.isRequired==true) {
                label = '*'+label;
            }
            return label;
        },
        saveTableVfeWithChanges(){
            if (this.selectedForm.vfe) {
                this.isLoading = false;
                if (this.selectedForm && this.displayOption=='Table') {
                    if (this.selectedForm.vfe.length > 0) {
                        this.selectedForm.vfe.forEach((vfe,vfeIdx)=>{
                            if (vfe.formFields && vfe.formFields.length > 0) {
                                let changedFields = vfe.formFields.filter(f=>{
                                    return f.fieldAnswerValue!=f.originalFieldAnswerValue
                                });
                                if (changedFields.length > 0) {
                                    let isLastItem = false;
                                    if (vfeIdx == this.selectedForm.vfe.length-1){
                                        isLastItem = true;
                                    }
                                    this.saveVfe(vfe,vfeIdx,true,isLastItem);
                                }
                            }
                        })
                    }
                } 
            }
        },
        convertDate(date) {
            return AppResourceUtil.convertDate(date)
        },
        convertFileSize(fsize) {
            return AppResourceUtil.convertFileSize(fsize)
        },
        deleteDropFileTable(vfe,index){
            vfe.dropFiles.splice(index, 1)
        },
        getTotalFileSizeTable(vfeDropFiles){
            if (vfeDropFiles.length > 0) {
                var total = vfeDropFiles.reduce((acc, file) => acc + file.size, 0);
                return AppResourceUtil.convertFileSize(total)
            } 
            return AppResourceUtil.convertFileSize(0)
        },
        checkFileTable(vfe){
            vfe.fileUploadError = false;
			vfe.fileUploadErroMsg = '';
			
            if (vfe.dropFiles.length > 0) {
                if (vfe.dropFiles[vfe.dropFiles.length-1]) {

                    let currFile = vfe.dropFiles[vfe.dropFiles.length-1];
                    let fileType = currFile.type;
                    let fileName = currFile.name;
                    let tempFileName = fileName.split('.');
                    let fileExt = tempFileName[tempFileName.length-1];

                    /* Check if file type is valid */ 
                    if (ArrayUtil.inArray(FileTypes,fileType)==false && 
                        ArrayUtil.inArray(FileTypes,fileExt)==false) {

                        /* INVALID FILE TYPE*/

                        // Remove last selected file with invalid type
                        vfe.dropFiles.splice(vfe.dropFiles.length-1,1);
                        vfe.fileUploadError = true;
                        vfe.fileUploadErroMsg = "Error: Unable to add file. Invalid file type detected.";
                        return false;
					}

                    /* 
                        Check if file size is allowed 
                        - Post request total should not be more than 100MB
                        - Number of files per request should not be more than 20
                        and total file size should not be more than 100MB
                        
                        500 000 bytes or 500KB for pictures
                    */ 
				   
				   	/* If file exceeds maximum file size limit */ 
                    if (currFile.size > MAX_FILESIZE_TOTAL ) {
						vfe.dropFiles.splice(vfe.dropFiles.length-1,1);
						vfe.fileUploadError = true;
						vfe.fileUploadErroMsg = "Error: Unable to add file. File is too large. You can upload files with size not greater than 100MB.";
						return false;
					}
					
					/* If total number of files is more than the limit (20)*/ 
				   	if (vfe.dropFiles.length > 20) {
						vfe.dropFiles.splice(vfe.dropFiles.length-1,1);
						vfe.fileUploadError = true;
						vfe.fileUploadErroMsg = "Error: Unable to add file. Maximum number of files is reached. Only 20 files are allowed per transaction.";
						return false;
					}
					
					/** 
					 * Compute total file size
					 * and check if it's less than the limit
					 * */ 
                    let totalFileSize = vfe.dropFiles.reduce((prev,f)=>{
						return prev + f.size;
					},0);

					if (totalFileSize > MAX_FILESIZE_TOTAL) {
						vfe.dropFiles.splice(vfe.dropFiles.length-1,1);
						vfe.fileUploadError = true;
						vfe.fileUploadErroMsg = "Error: Unable to add file. Maximum file size is reached. Only up to 100MB is allowed per transaction.";
						return false;
					}
                }
            }
        },
		uploadFilesTable(vfeId,vfeData){
            /** 
             * vfeId can come from newly-created vfe or from 
             * saveVfe function from Table view;
             * vfeData - selected vfe from Table view
             * */ 
            
            let logData = {
                validationCardIdFk : null,
                vfeIdFk : vfeId,
                activityByUser : this.profile.userId,
                activitySection : VFE_SECTION_LOG,
                activityMessageLog : "Uploaded supporting document/file.",
                activityBody : ''
            };

            let formData = new FormData();

			if (vfeData && vfeData.dropFiles && vfeData.dropFiles.length > 0) {

                let fileNames = [];

				vfeData.dropFiles.forEach((file,i)=>{
                    // Get filenames for logs
                    fileNames.push(file.name);
                    // Add each file to formData
                    formData.append('files['+i+']', file);
                });

                logData.activityBody = fileNames.join(", ");
                
                formData.append('uploadedBy',this.profile.userId);
                formData.append('reportingYear',this.selectedReportingYear);
                formData.append('vfeId',vfeId);

                if (this.displayOption=='List') {
                    if (this.selectedVfe) {
                        formData.append('vcardIdFk',this.selectedVfe.validationCardIdFk);
                        logData.validationCardIdFk = this.selectedVfe.validationCardIdFk;
                    }
                }
                else {
                    if (vfeData) {
                        formData.append('vcardIdFk',vfeData.validationCardIdFk);   
                        logData.validationCardIdFk = vfeData.validationCardIdFk;
                    }
                }    
                
                if (logData.validationCardIdFk === undefined) {
                    this.$dialog.alert({
                        title: 'Error',
                        message: 'Unable to proceed. Validation Card Id is missing. Please refresh the page and try again.',
                        type: 'is-danger'
                    });
                    return false
                }

                this.showLoading()
                FilesApi.addToVfe(formData)
                .then(response=>{
                    this.closeLoading()
                    if (response.data) {
                        if (!response.data.error) {
                            if (response.data.success==true) {

                                // Log file upload activity
                                this.logActivity(logData);
                                
                                this.$notification.open({
                                    duration: 5000,
                                    message: 'Files uploaded successfully.',
                                    position: 'is-bottom-left',
                                    type: 'is-success'
                                });

                                // Reset upload form
                                vfeData.dropFiles = [];

                                // Refresh data
                                this.refreshFiles(vfeId);                            
                                return false;
                            }
                            else {
                                this.$notification.open({
                                    duration: 5000,
                                    message: 'A problem occurred while uploading files. Please try again.',
                                    position: 'is-bottom-left',
                                    type: 'is-danger'
                                });
                                return false;
                            }
                        }
                        else {
                            this.promptServerError({response},'File.addToVfe');
                            return false;
                        }
                    }
                })
                .catch(error=>{
                    this.closeLoading()
                    this.promptServerError(error,'File.addToVfe');
                    return false;
                });

			}			
  
        },
        showLoading(){
            this.globalLoading = null
            this.globalLoading = this.$loading.open({
                container: null
            })
        },
        closeLoading(){
            if (this.globalLoading !== null) {
                this.globalLoading.close()
            }
            this.globalLoading = null
        }
    }
}
</script>

<template>
    <section>
        <p class="subtitle page-title">Workspace</p>

        <!-- Reporting Year Selection -->
        <div class="base-box--sidepadded margin-left margin-btm--med">
            <div class="field is-grouped">
                <div class="control">
                    <b-dropdown
                        v-model="selectedReportingYear">
                        <button class="button is-primary is-outlined"
                            type="button"
                            slot="trigger">
                            <template
                                v-if="selectedReportingYear">
                                <strong>Reporting Year ({{selectedReportingYear}})</strong>
                            </template>
                            <template
                                v-else>
                                <strong>Select Reporting Year</strong>
                            </template>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                        <b-dropdown-item
                            v-for="(year,yearIdx) in reportingYearLov"
                            v-bind:key="yearIdx"
                            v-bind:value="year"
                            v-on:click="selectReportingYear($event,year)">
                            <h4>{{year}}</h4>
                        </b-dropdown-item>
                        
                    </b-dropdown>
                </div>
                <div class="control"
                    v-if="inProgressVcards.length > 0">
                    <b-dropdown 
                        v-model="selectedValidationCardId" 
                        aria-role="list">
                        <button class="button is-primary" type="button" slot="trigger">
                            <template v-if="vcardDisplayName">
                                <span>{{vcardDisplayName}}</span>
                            </template>
                            <template v-else>
                                <span>Choose Validation Card</span>
                            </template>
                            <b-icon icon="menu-down"></b-icon>
                        </button>

                    
                        <b-dropdown-item 
                            aria-role="listitem"
                            v-for="vcard in inProgressVcards"
                            v-bind:key="vcard.validationCardId"
                            v-bind:value="vcard.validationCardId"
                            v-on:click="selectVcard(vcard)">
                            <div class="media">
                                <div class="media-content">
                                    <h3 class="has-text-weight-semibold">{{vcard.reportingUnit ? vcard.reportingUnit : vcard.reportingEntity}}</h3>
                                    <small>{{vcard.cardLevel}}</small>
                                </div>
                            </div>
                        </b-dropdown-item>

                    </b-dropdown>
                </div>
                <div class="control"
                    v-if="inProgressVcards.length > 0 && selectedValidationCardId">
                    <button type="button"
                        class="button is-light tooltip is-tooltip-top"
                        data-tooltip="Refresh data"
                        v-on:click="refreshData(false)">
                        <span class="icon">
                            <i class="fas fa-redo"></i>
                        </span>
                    </button>
                </div>
                <div class="control"
                    style="padding-top:0.1rem;"
                    v-if="inProgressVcards.length > 0 && selectedValidationCardId">
                    <Timer 
                        v-if="dueDateEpoch!=null"
                        :dueDate="dueDateEpoch"/>
                </div>
            </div>
        </div>
        
        <section class="section no-padd--top app-view app-view--user"
            v-if="selectedValidationCard!=null && !isLoading"> 

            <b-tabs
                v-model="activeTab"
                type="is-boxed">
                
                <!-- VFEs -->
                <b-tab-item label="Forms"
                    icon-pack="fa"
                    icon="file-alt">
                    <div class="columns">
                        <!-- Forms List -->
                        <div class="column list-panel"
                            v-if="vcardForms.length > 0 && showList==true">
                            <!-- Filter and Search -->
                            <div class="base-box box-wd--fill base-box--tbpadded">
                                <div class="columns">
                                    <div class="column">
                                        <b-field expanded>
                                            <b-input placeholder="Search Form"
                                                type="search"
                                                icon="magnify"
                                                v-model="searchFormKeyword">
                                            </b-input>
                                            <p class="control">
                                                <button class="button is-info">Search</button>
                                            </p>
                                        </b-field>
                                    </div>
                                    <!-- <div class="column has-text-right">
                                        <a class="button is-primary">
                                            <span>
                                                <i class="fas fa-angle-left"></i>
                                            </span>
                                        </a>
                                        <a class="button is-primary">
                                            <span>
                                                <i class="fas fa-angle-right"></i>
                                            </span>
                                        </a>
                                    </div> -->
                                </div>
                            </div>
                            <!-- Main List -->
                            <div>
                                <b-collapse class="card"
                                    v-for="(form,formIdx) in filterValidationEntryForms"
                                    v-bind:key="form.formId"
                                    v-bind:ref="'formIdx'+formIdx">
                                    <div 
                                        slot="trigger"
                                        slot-scope="props"
                                        class="card-header collapse-header">
                                        <p class="card-header-title collapse-title">
                                            <span class="tag is-white has-text-success"
                                                v-if="form.formSubmissionType!='Single'">
                                                {{form.formSubmissionType}}
                                            </span> 
                                            &nbsp; 
                                            {{form.formName}}
                                        </p>
                                        
                                        <!-- Actions -->
                                        <div class="field is-grouped collapse-action">
                                            <p class="control"
                                                v-if="(form.displayOption=='List' && 
                                                        displayOption=='List') ||
                                                      (form.displayOption=='Table' &&
                                                       displayOption=='List' && 
                                                       selectedForm && 
                                                       selectedForm.formIdFk==form.formIdFk)">
                                                <a v-if="form.formSubmissionType=='Multiple'"
                                                    class="button is-link is-inverted tooltip is-tooltip-left"
                                                    data-tooltip="Add new entry"
                                                    v-on:click.stop.prevent="addFormEntry(form,'list')">
                                                    <span class="icon">
                                                        <i class="fas fa-plus"></i>
                                                    </span>
                                                </a>
                                            </p>
                                            <p class="control"
                                                v-if="form.displayOption=='Table'">
                                                <a class="button is-link is-inverted tooltip is-tooltip-right"
                                                    data-tooltip="Open Form"
                                                    v-on:click.stop.prevent="openFormTable(form,null,'list')">
                                                    <span class="icon">
                                                        <i class="fas fa-share"></i>
                                                    </span>
                                                </a>
                                            </p>
                                        </div>

                                        <a class="card-header-icon">
                                            <b-icon
                                                v-if="form.displayOption=='List' ||
                                                      (form.displayOption=='Table' &&
                                                       displayOption=='List' && 
                                                       selectedForm && 
                                                       selectedForm.formIdFk==form.formIdFk)"
                                                :icon="props.open ? 'menu-up' : 'menu-down'">
                                            </b-icon>
                                            <!-- <span class="icon tooltip is-tooltip-left"
                                                data-tooltip="Open"
                                                v-if="form.displayOption=='Table'">
                                                <i class="fas fa-share"></i>
                                            </span> -->
                                        </a>
                                    </div>

                                    <div v-if="form.displayOption=='List' ||
                                                (form.displayOption=='Table' &&
                                                displayOption=='List' && 
                                                selectedForm && 
                                                selectedForm.formIdFk==form.formIdFk)">
                                        <!-- main list item  -->
                                        <div v-if="form.vfe.length > 0">
                                            <div class="box form-entry-box clickable"
                                                v-for="(entry,entryIdx) in form.vfe"
                                                v-bind:key="entryIdx"
                                                v-bind:class="{'active-form-entry':activeFormEntry!==null && activeFormEntry.id==entry.id && entry.submittedForm.title==selectedForm.title}"
                                                v-on:click="openFormEntry(entry,form,'list')">
                                                <p><strong>Entry ID:</strong> {{entry.vcardFormEntryId}}</p>
                                                <p><strong>Last Updated by:</strong> {{entry.lastUpdatedByName}} on {{entry.dateLastUpdated}}</p>
                                            </div>
                                        </div>
                                        <div class="new-form-entry-box"
                                            v-if="(form.vfe.length==0 && form.formSubmissionType!=='Multiple') || form.formSubmissionType=='Multiple'">
                                            <div class="box has-background-white has-text-centered clickable add-entry"
                                                v-on:click="addFormEntry(form,'list')">
                                                <span class="icon has-text-grey-light tooltip is-tooltip-right"
                                                    data-tooltip="Add new entry">
                                                    <i class="fas fa-plus"></i>
                                                </span>
                                                <span class="has-text-grey-light">Add new entry</span>
                                            </div>
                                        </div>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>

                        <!-- Workspace/Form View -->
                        <div class="column workspace-panel"
                            v-bind:class="{'is-full':!showList,'is-two-thirds':showList}">
                            
                            <div
                                v-if="selectedForm!=null && !vfePromiseLoading"
                                class="box">

                                <div class="columns">
                                    <div class="column is-1 has-text-left">
                                        <a class="button is-info tooltip is-tooltip-right"
                                            v-bind:class="{'is-outlined':showList}"
                                            data-tooltip="Hide/show form entries list"
                                            v-on:click="toggleList">
                                            <span>
                                                <i class="fas fa-bars"></i>
                                            </span>
                                        </a>
                                    </div>
                                    <div class="column no-padd">
                                        <p class="title form-name">{{selectedForm.formName}}</p>
                                    </div>
                                    <div class="column is-1 no-padd has-text-right">
                                        <a class="button is-white"
                                            v-on:click="closeForm">
                                            <span class="icon tooltip is-tooltip-top"
                                                data-tooltip="Close form">
                                                <i class="fas fa-times"></i>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                        
                                <!-- Form + Save Actions -->
                                <div class="columns">

                                    <div class="column"
                                        v-if="displayOption=='List' && selectedVfe!=null">
                                        <span class="heading"
                                            v-if="selectedVfe && !selectedVfe.vcardFormEntryId">
                                            New Entry
                                        </span>
                                        <span class="heading"
                                            v-if="selectedVfe && selectedVfe.vcardFormEntryId">
                                            Entry ID: {{selectedVfe.vcardFormEntryId}}
                                        </span>
                                        <i v-if="selectedVfe && selectedVfe.vcardFormEntryId">Last updated by: {{selectedVfe.lastUpdatedByName}} on {{selectedVfe.dateLastUpdated}}</i>
                                    </div>

                                    <div class="column has-text-right">
                                        <a class="button is-danger is-outlined"
                                            v-if="selectedForm.formSubmissionType=='Multiple' && displayOption=='List' && 
                                                  selectedVfe && selectedVfe.vcardFormEntryId"
                                            v-on:click="confirmDelete">
                                            <span>Delete Entry</span>
                                        </a>

                                        <a class="button is-light"
                                            v-if="selectedForm.formSubmissionType=='Multiple' && displayOption=='List' && 
                                                  selectedVfe && selectedVfe.vcardFormEntryId"
                                            v-on:click="addFormEntry(selectedVfe,'workspace')">
                                            <span>Add New Entry</span>
                                        </a>

                                        <a class="button is-light"
                                            v-if="selectedForm.formSubmissionType=='Multiple' && displayOption=='Table'"
                                            v-on:click="addFormTableEntry('workspace')">
                                            <span>Add New Entry</span>
                                        </a>
                                        
                                        
                                        <a class="button is-success"
                                            v-on:click="saveForm"
                                            v-if="selectedForm && displayOption=='List' && selectedVfe">
                                            <!-- v-bind:disabled="(selectedVfe && !selectedVfe.changedFields && !isVfeValid) || (selectedVfe && selectedVfe.changedFields && !hasChangedFields)"> -->
                                            <span class="icon">
                                                <i class="fas fa-check"></i>
                                            </span>
                                            <span>Save</span>
                                        </a>

                                        <!-- <a class="button is-light"
                                            v-on:click="closeForm">
                                            <span class="icon tooltip is-tooltip-top"
                                                data-tooltip="Close form">
                                                <i class="fas fa-times"></i>
                                            </span>
                                            <span>Close</span>
                                        </a> -->
                                    </div>
                                </div>

                                <b-message 
                                    class="no-padd"
                                    type="is-danger"
                                    v-if="errorFields.length > 0">
                                    Some <span class="has-text-weight-semibold">*mandatory fields</span> are not yet filled out. Please check.
                                </b-message>

                                <div
                                    v-if="selectedForm && selectedForm.displayOption=='List'" 
                                    class="has-text-left is-italic">
                                    Fields marked with * are mandatory.
                                </div>

                                <!-- Display Options -->
                                <div class="columns"
                                    v-if="selectedForm && selectedForm.displayOption=='Table'">

                                    <div class="column has-text-left is-italic"
                                        style="margin-top:0.5rem;">
                                        Fields marked with * are mandatory.
                                    </div>

                                    <div class="column has-text-right">
                                        <a class="button is-info"
                                            v-bind:class="{'is-outlined':displayOption!=='List'}"
                                            v-on:click="changeDisplay('List')">
                                            <span class="icon">
                                                <i class="fas fa-th-list"></i>
                                            </span>
                                        </a>
                                    
                                        <a class="button is-info"
                                            v-bind:class="{'is-outlined':displayOption!=='Table'}"
                                            v-on:click="changeDisplay('Table')">
                                            <span class="icon">
                                                <i class="fas fa-columns"></i>
                                            </span>
                                        </a>
                                    </div>

                                </div>

                                <!-- Table View (Save Options) -->
                                <!-- div 
                                    v-if="selectedForm && selectedForm.displayOption=='Table' && multipleVfeChangesInTable==true">
                                    <b-message 
                                        class="no-padd"
                                        type="is-info">
                                        <p>
                                            Looks like you have changes. Click 'Save All' button to save all form entries with changes.
                                        </p>
                                        <a class="button is-success"
                                            type="button"
                                            v-on:click="saveTableVfeWithChanges"
                                            style="margin-top:2px">
                                            <span>Save All</span>
                                        </a>
                                    </b-message>
                                </div -->

                                <!-- Fields -->

                                <section class="main-form-body">
                                    
                                    <!-- <b-loading 
                                        v-bind:is-full-page="isFullPage" 
                                        v-bind:active.sync="vfePromiseLoading" 
                                        v-bind:can-cancel="false">
                                        <span class="subtitle">Loading form fields ..</span>
                                    </b-loading> -->

                                    <!-- List view -->
                                    <div v-if="selectedForm && displayOption=='List'">

                                        <div v-if="selectedVfe && selectedVfe.formFields">
                                            <div 
                                                class="field-group-box"
                                                v-for="(grp,grpIdx) in groupedFields"
                                                v-bind:key="grpIdx">

                                                <p class="subtitle"
                                                    v-if="grp.fieldGroupName!=''"
                                                    style="margin-bottom:0.4rem">{{grp.fieldGroupName}}</p>

                                                <p class="is-7"
                                                    v-if="grp.fieldGroupSubLabel!=null && grp.fieldGroupSubLabel!=''"
                                                    style="margin-bottom:0.9rem">{{grp.fieldGroupSubLabel}}</p>
                                
                                                <div 
                                                    v-for="(field,fieldIdx) in grp.fields"
                                                    v-bind:key="fieldIdx">

                                                    <!-- *** INPUT TEXTS *** -->
                                                    <div class="form-field-label">
                                                        <span class="has-text-weight-bold"
                                                            :class="(hasError(field.fieldId) && clearFieldError(field)==false) ? 'has-text-danger': ''">{{setFieldLabel(field)}}</span>
                                                        <span class="form-field-sublabel" v-if="field.fieldSubLabel"><br/>{{field.fieldSubLabel}}</span>
                                                    </div>
                                                    
                                                    <!-- Textfield -->
                                                    <!-- {{field.fieldSubLabel}} -->
                                                    <b-field
                                                        v-if="field.inputType=='textfield'"
                                                        class="form-field-input"
                                                        :type="(hasError(field.fieldId) && clearFieldError(field)==false) ? 'is-danger': ''">
                                                        <b-input 
                                                            type="text"
                                                            v-model="field.fieldAnswerValue"
                                                            v-bind:required="field.isRequired"></b-input>
                                                    </b-field>

                                                    <!-- Textarea -->
                                                    <b-field
                                                        v-if="field.inputType=='textarea'"
                                                        class="form-field-input"
                                                        :type="(hasError(field.fieldId) && clearFieldError(field)==false) ? 'is-danger': ''">
                                                        <b-input 
                                                            maxlength="500" 
                                                            type="textarea"
                                                            v-model="field.fieldAnswerValue"
                                                            v-bind:required="field.isRequired"></b-input>
                                                    </b-field>

                                                    <!-- *** NUMBER INPUTS *** -->

                                                    <!-- Number -->
                                                    <b-field
                                                        v-if="field.inputType=='number'"
                                                        class="form-field-input"
                                                        :type="(hasError(field.fieldId) && clearFieldError(field)==false) ? 'is-danger': ''">
                                                        <b-input  
                                                            type="number"
                                                            min="0"
                                                            v-model="field.fieldAnswerValue"
                                                            v-bind:required="field.isRequired"></b-input>
                                                    </b-field>

                                                    <!-- Decimal -->
                                                    <b-field
                                                        v-if="field.inputType=='decimal'"
                                                        class="form-field-input"
                                                        :type="(hasError(field.fieldId) && clearFieldError(field)==false) ? 'is-danger': ''">
                                                        <b-input  
                                                            type="text"
                                                            v-model="field.fieldAnswerLabel"
                                                            v-bind:required="field.isRequired"
                                                            v-bind:value="field.fieldAnswerValue"
                                                            v-cleave="masks.numeral"
                                                            v-on:input.native="onInput($event,field)"></b-input>
                                                    </b-field>

                                                    <!-- Integer -->
                                                    <b-field
                                                        v-if="field.inputType=='integer'"
                                                        class="form-field-input"
                                                        :type="(hasError(field.fieldId) && clearFieldError(field)==false) ? 'is-danger': ''">
                                                        <b-input  
                                                            type="number"
                                                            min="0"
                                                            v-model="field.fieldAnswerValue"
                                                            v-bind:required="field.isRequired"></b-input>
                                                    </b-field>

                                                    
                                                    <!-- *** SELECTION INPUTS / WITH OPTIONS *** -->

                                                    <!-- Yes or No -->
                                                    <b-field
                                                        v-if="field.inputType=='yes or no'"
                                                        class="form-field-input"
                                                        :type="(hasError(field.fieldId) && clearFieldError(field)==false) ? 'is-danger': ''">
                                                        <div class="buttons has-addons"
                                                            v-if="field.inputType=='yes or no'">
                                                            <span class="button"
                                                                v-bind:class="{'is-info':field.fieldAnswerValue=='Yes'}"
                                                                v-on:click="field.fieldAnswerValue='Yes'">Yes</span>
                                                            <span class="button"
                                                                v-bind:class="{'is-info':field.fieldAnswerValue=='No'}"
                                                                v-on:click="field.fieldAnswerValue='No'">No</span>
                                                        </div>
                                                    </b-field>

                                                    <!-- Dropdown -->
                                                    <b-field
                                                        v-if="field.inputType=='dropdown' && field.options.length"
                                                        class="form-field-input"
                                                        :type="(hasError(field.fieldId) && clearFieldError(field)==false) ? 'is-danger': ''">
                                                        <!-- Custom Options -->
                                                        <b-select
                                                            v-if="field.optionType=='custom' && field.options.length > 0"
                                                            v-model="field.fieldAnswerValue"
                                                            v-bind:required="field.isRequired">
                                                            <option v-for="opt in field.options"
                                                                v-bind:key="opt.optionId"
                                                                v-bind:value="opt.optionValue">
                                                                {{opt.optionValue}}
                                                            </option>
                                                        </b-select>

                                                        <!-- Preset Options -->
                                                        <b-select
                                                            v-if="field.optionType=='preset' && field.options.length==1 && 
                                                            field.options[0].optionValue=='Reporting Entities'"
                                                            v-model="field.fieldAnswerValue"
                                                            v-bind:required="field.isRequired">
                                                            <option 
                                                                v-for="(opt,optIdx) in presetLovs['Reporting Entities']"
                                                                v-bind:key="optIdx"
                                                                v-bind:value="opt.optionValue">
                                                                {{opt.optionLabel}}
                                                            </option>
                                                        </b-select>

                                                        <b-select
                                                            v-if="field.optionType=='preset' && field.options.length==1 && 
                                                            field.options[0].optionValue=='Reporting Entities & Units'"
                                                            v-model="field.fieldAnswerValue"
                                                            v-bind:required="field.isRequired">
                                                            <option 
                                                                v-for="(opt,optIdx) in presetLovs['Reporting Entities & Units']"
                                                                v-bind:key="optIdx"
                                                                v-bind:value="opt.optionValue">
                                                                {{opt.optionLabel}}
                                                            </option>
                                                        </b-select>
                                                        
                                                    </b-field>

                                                    <!-- Checkbox -->
                                                    <b-field
                                                        v-if="field.inputType=='checkbox' && field.options.length"
                                                        class="form-field-input"
                                                        :type="(hasError(field.fieldId) && clearFieldError(field)==false) ? 'is-danger': ''">
                                                        <div class="block checkbox-block">
                                                            <b-checkbox v-for="opt in field.options"
                                                                v-bind:key="opt.optionId"
                                                                v-model="field.fieldAnswerValue"
                                                                v-bind:native-value="opt.optionValue"
                                                                v-bind:required="field.isRequired">
                                                                {{opt.optionValue}}
                                                            </b-checkbox>
                                                        </div>
                                                    </b-field>

                                                    <!-- Radio -->
                                                    <b-field
                                                        v-if="field.inputType=='radio' && field.options.length"
                                                        class="form-field-input"
                                                        :type="(hasError(field.fieldId) && clearFieldError(field)==false) ? 'is-danger': ''">
                                                        <div class="block radio-block">
                                                            <b-radio 
                                                                v-for="opt in field.options"
                                                                v-bind:key="opt.optionId"
                                                                v-bind:name="'radio'+field.fieldId"
                                                                v-bind:native-value="opt.optionValue"
                                                                v-model="field.fieldAnswerValue"
                                                                v-bind:required="field.isRequired">
                                                                {{opt.optionValue}}
                                                            </b-radio>
                                                        </div>
                                                    </b-field>

                                                    <!-- *** DATE INPUT *** -->

                                                    <!-- Date Inputs -->
                                                    <b-field
                                                        v-if="field.inputType=='date' || 
                                                              field.inputType=='date range (start date)' ||
                                                              field.inputType=='date range (end date)'"
                                                        class="form-field-input"
                                                        :type="(hasError(field.fieldId) && clearFieldError(field)==false) ? 'is-danger': ''">
                                                        <b-datepicker
                                                            v-bind:show-week-number="true"
                                                            placeholder="Click to select date"
                                                            icon="calendar-today"
                                                            v-model="field.fieldAnswerValue"
                                                            v-bind:required="field.isRequired">
                                                        </b-datepicker>
                                                    </b-field>
                                                    
                                                </div>

                                            </div>
                                        </div>

                                        <hr v-if="selectedForm && selectedForm.filesEnabled && displayOption=='List'"/>

                                        <div
                                            v-if="selectedForm && selectedForm.filesEnabled && displayOption=='List'" 
                                            class="box">
                                            <h3 class="subtitle is-6 has-text-weight-bold">Add Supporting Schedules and Documents</h3>
                                            <ul v-if="selectedVfe && selectedVfe.files.length > 0"
                                                class="vfe-files-list">
                                                <li v-for="(file,fileIdx) in selectedVfe.files"
                                                    v-bind:key="fileIdx">
                                                   
                                                    <span class="subtitle">{{file.vfeFileTitle}}</span>
                                                    <div class="has-text-left">
                                                        Uploaded by {{file.uploadedByName}} on 
                                                        {{file.dateUploaded}}
                                                    </div>
                                                    <div class="buttons">
                                                        <a class="button is-light"
                                                            type="button"
                                                            v-on:click="confirmDeleteFile(file,fileIdx)">
                                                            <span class="icon">
                                                                <i class="fas fa-trash-alt"></i>
                                                            </span>
                                                            <span>Delete</span>
                                                        </a>
                                                        <a class="button is-light"
                                                            type="button"
                                                            v-on:click="openFile(file)">
                                                            <span class="icon">
                                                                <i class="fas fa-external-link-alt"></i>
                                                                <!-- <i class="fas fa-file-download"></i> -->
                                                            </span>
                                                            <span>Open</span>
                                                        </a>
                                                    </div>
                                                    
                                                </li>
                                            </ul>
                                            <b-message 
                                                type="is-info">
                                                <ul>
                                                    <li>- Only .pdf, .ppt/.pptx, .doc/docx, and .xls/xlsx are supported.</li>
                                                    <li>- Multiple files can be uploaded but not more than a total of 20 files.</li> 
                                                    <li>- Total file size should NOT be more than 100MB.</li>
                                                    <li>- In case total file size exceeds 100MB, remove a few files then upload again after clicking 'Save'.</li>
                                                    <li>- Files with the same filename will be overwritten upon selection</li> 
                                                    <li>- For large files, a loading screen will show up to indicate that the upload is still in progress. </li>
                                                    <li>- DO NOT CLOSE this page while the upload is ongoing.</li>
                                                </ul>
                                            </b-message>
                                            <b-notification
                                                v-bind:active.sync="fileUploadError" 
                                                type="is-danger"
                                                aria-close-label="Close notification"
                                                role="alert">
                                                {{fileUploadErroMsg}}
                                            </b-notification>
                                            <b-field>
                                                <b-upload v-model="dropFiles"
                                                    multiple
                                                    drag-drop
                                                    v-on:input="checkFile"
                                                    v-bind:disabled="dropFiles.length==maxNumFiles">
                                                    <section class="section">
                                                        <div class="content has-text-centered">
                                                            <p>
                                                                <b-icon
                                                                    icon="upload"
                                                                    size="is-large">
                                                                </b-icon>
                                                            </p>
                                                            <p>Drop your files here or click to upload</p>
                                                        </div>
                                                    </section>
                                                </b-upload>
                                            </b-field>

                                            <div class="tags">
                                                <span v-for="(file, index) in dropFiles"
                                                    v-bind:key="index"
                                                    class="tag is-info is-medium" >
                                                    {{file.name}} ({{convertFileSize(file.size)}})
                                                    <button class="delete is-small"
                                                        type="button"
                                                        v-on:click="deleteDropFile(index)">
                                                    </button>
                                                </span>
                                                <span
                                                    v-if="dropFiles.length > 0" 
                                                    class="tag is-dark is-medium">
                                                    Total File Size: {{totalFileSize}}
                                                </span>
                                            </div>
                                        </div>
                                        
                                        <hr />

                                        <a class="button is-success"
                                            v-on:click="saveForm">
                                            <!-- v-bind:disabled="(selectedVfe && !selectedVfe.changedFields && !isVfeValid) || (selectedVfe && selectedVfe.changedFields && !hasChangedFields)" -->
                                            <span class="icon">
                                                <i class="fas fa-check"></i>
                                            </span>
                                            <span>Save</span>
                                        </a>

                                    </div>

                                    <!-- Table View -->
                                    <div v-if="selectedForm && displayOption=='Table'"
                                        class="ore-table-wrapper"
                                        v-bind:class="{'ore-table-wrapper--expanded' : !showList }">

                                        <table class="ore-table">
                                            <thead>
                                                <tr v-if="selectedForm && selectedForm.formFields.length > 0">
                                                    <th style="min-width:100px;">
                                                        Actions
                                                    </th>
                                                    <th v-for="(col,colIdx) in selectedForm.formFields"
                                                        v-bind:key="colIdx"
                                                        style="min-width:100px;max-width:200px;">
                                                        <span v-if="col.isRequired">*</span><!--
                                                        --><span v-if="col.fieldGroupLabel" class="form-field-grouplabel-th">{{col.fieldGroupLabel}} - </span><!--
                                                        -->{{col.fieldLabel}}<span class="form-field-sublabel-th" v-if="col.fieldSubLabel"><br/>{{col.fieldSubLabel}}</span>
                                                    </th>
                                                    <th v-if="selectedForm && selectedForm.filesEnabled"
                                                        style="min-width:100px;max-width:200px;">
                                                        Supporting Schedules and Documents
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="selectedForm && selectedForm.vfe.length > 0">
                                                <tr v-for="(vfe,vfeIdx) in selectedForm.vfe"
                                                    v-bind:key="vfeIdx">
                                                    <td style="min-width:100px;">
                                                        <button
                                                            type="button"
                                                            class="button is-danger is-outlined"
                                                            title="Delete Entry"
                                                            v-if="selectedForm.formSubmissionType=='Multiple'"
                                                            v-bind:disabled="vfeIdx==0"
                                                            v-on:click="confirmDeleteTableVfe(vfe,vfeIdx)">
                                                            <span class="icon">
                                                                <i class="fas fa-minus-circle"></i>
                                                            </span>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            class="button is-success"
                                                            title="Save Entry"
                                                            v-if="selectedForm.formSubmissionType=='Multiple'"
                                                            v-on:click="saveVfe(vfe,vfeIdx)">
                                                            <!-- v-bind:disabled="(!vfe.changedFields && !isTableVfeValid(vfe) && (vfe.dropFiles && vfe.dropFiles.length == 0)) || (vfe.changedFields && hasTableVfeChangedFields(vfe)==false && (vfe.dropFiles && vfe.dropFiles.length == 0)) "> -->
                                                            <span class="icon">
                                                                <i class="fas fa-check"></i>
                                                            </span>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            class="button is-success is-outlined"
                                                            title="Save Entry"
                                                            v-if="selectedForm.formSubmissionType=='Single'"
                                                            v-on:click="saveVfe(vfe,vfeIdx)">
                                                            <!-- v-bind:disabled="(!vfe.changedFields && !isTableVfeValid(vfe) && (vfe.dropFiles && vfe.dropFiles.length == 0)) || (vfe.changedFields && hasTableVfeChangedFields(vfe)==false && (vfe.dropFiles && vfe.dropFiles.length == 0))"> -->
                                                            <span class="icon">
                                                                <i class="fas fa-check"></i>
                                                            </span>
                                                            <span>Save</span>
                                                        </button>
                                                    </td>
                                                    <td v-for="(col,colIdx) in vfe.formFields"
                                                        v-bind:key="colIdx"
                                                        style="min-width:100px;max-width:200px;">

                                                        <!-- *** INPUT TEXTS *** -->

                                                        <!-- Textfield -->
                                                        <b-field
                                                            v-if="col.inputType=='textfield'"
                                                            :type="(hasError(col.fieldId) && clearFieldError(col)==false) ? 'is-danger': ''">
                                                            <b-input 
                                                                type="text"
                                                                v-model="col.fieldAnswerValue"
                                                                v-bind:required="col.isRequired"></b-input>
                                                        </b-field>
                                                        
                                                        <!-- Textarea -->
                                                        <b-field
                                                            v-if="col.inputType=='textarea'"
                                                            :type="(hasError(col.fieldId) && clearFieldError(col)==false) ? 'is-danger': ''">
                                                            <b-input 
                                                                maxlength="500" 
                                                                type="textarea"
                                                                v-model="col.fieldAnswerValue"
                                                                v-bind:required="col.isRequired"></b-input>
                                                        </b-field>

                                                        <!-- *** NUMBER INPUTS *** -->

                                                        <!-- Number -->
                                                        <b-field
                                                            v-if="col.inputType=='number'"
                                                            :type="(hasError(col.fieldId) && clearFieldError(col)==false) ? 'is-danger': ''">
                                                            <b-input  
                                                                type="number"
                                                                min="0"
                                                                v-model="col.fieldAnswerValue"
                                                                v-bind:required="col.isRequired"></b-input>
                                                        </b-field>

                                                        <!-- Decimal -->
                                                        <b-field
                                                            v-if="col.inputType=='decimal'"
                                                            :type="(hasError(col.fieldId) && clearFieldError(col)==false) ? 'is-danger': ''">
                                                            <b-input  
                                                                type="text"
                                                                v-model="col.fieldAnswerLabel"
                                                                v-bind:required="col.isRequired"
                                                                v-bind:value="col.fieldAnswerValue"
                                                                v-cleave="masks.numeral"
                                                                v-on:input.native="onInput($event,col)"></b-input>
                                                        </b-field>

                                                        <!-- Integer -->
                                                        <b-field
                                                            v-if="col.inputType=='integer'"
                                                            :type="(hasError(col.fieldId) && clearFieldError(col)==false) ? 'is-danger': ''">
                                                            <b-input  
                                                                type="number"
                                                                min="0"
                                                                v-model="col.fieldAnswerValue"
                                                                v-bind:required="col.isRequired"></b-input>
                                                        </b-field>

                                                        <!-- *** SELECTION INPUTS / WITH OPTIONS *** -->

                                                            <!-- Yes or No -->
                                                        <b-field
                                                            v-if="col.inputType=='yes or no'"
                                                            :type="(hasError(col.fieldId) && clearFieldError(col)==false) ? 'is-danger': ''">
                                                            <div class="buttons has-addons"
                                                                v-if="col.inputType=='yes or no'">
                                                                <span class="button"
                                                                    v-bind:class="{'is-info':col.fieldAnswerValue=='Yes'}"
                                                                    v-on:click="col.fieldAnswerValue='Yes'">Yes</span>
                                                                <span class="button"
                                                                    v-bind:class="{'is-info':col.fieldAnswerValue=='No'}"
                                                                    v-on:click="col.fieldAnswerValue='No'">No</span>
                                                            </div>
                                                        </b-field>
                                                        
                                                        <!-- Dropdown -->
                                                        <b-field
                                                            v-if="col.inputType=='dropdown' && col.options.length"
                                                            :type="(hasError(col.fieldId) && clearFieldError(col)==false) ? 'is-danger': ''">
                                                            <!-- Custom Options -->
                                                            <b-select
                                                                v-if="col.optionType=='custom' && col.options.length > 0"
                                                                v-model="col.fieldAnswerValue"
                                                                v-bind:required="col.isRequired">
                                                                <option v-for="opt in col.options"
                                                                    v-bind:key="opt.optionId"
                                                                    v-bind:value="opt.optionValue">
                                                                    {{opt.optionValue}}
                                                                </option>
                                                            </b-select>

                                                            <!-- Preset Options -->
                                                            <b-select
                                                                v-if="col.optionType=='preset' && col.options.length==1 && 
                                                                col.options[0].optionValue=='Reporting Entities'"
                                                                v-model="col.fieldAnswerValue"
                                                                v-bind:required="col.isRequired">
                                                                <option 
                                                                    v-for="(opt,optIdx) in presetLovs['Reporting Entities']"
                                                                    v-bind:key="optIdx"
                                                                    v-bind:value="opt.optionValue">
                                                                    {{opt.optionLabel}}
                                                                </option>
                                                            </b-select>

                                                            <b-select
                                                                v-if="col.optionType=='preset' && col.options.length==1 && 
                                                                col.options[0].optionValue=='Reporting Entities & Units'"
                                                                v-model="col.fieldAnswerValue"
                                                                v-bind:required="col.isRequired">
                                                                <option 
                                                                    v-for="(opt,optIdx) in presetLovs['Reporting Entities & Units']"
                                                                    v-bind:key="optIdx"
                                                                    v-bind:value="opt.optionValue">
                                                                    {{opt.optionLabel}}
                                                                </option>
                                                            </b-select>
                                                            
                                                        </b-field>

                                                        <!-- Checkbox -->
                                                        <b-field
                                                            v-if="col.inputType=='checkbox' && col.options.length"
                                                            :type="(hasError(col.fieldId) && clearFieldError(col)==false) ? 'is-danger': ''">
                                                            <div class="block checkbox-block">
                                                                <b-checkbox v-for="opt in col.options"
                                                                    v-bind:key="opt.optionId"
                                                                    v-bind:native-value="opt.optionValue"
                                                                    v-model="col.fieldAnswerValue"
                                                                    v-bind:required="col.isRequired">
                                                                    {{opt.optionValue}}
                                                                </b-checkbox>
                                                            </div>
                                                        </b-field>

                                                        <!-- Radio -->
                                                        <b-field
                                                            v-if="col.inputType=='radio' && col.options.length"
                                                            :type="(hasError(col.fieldId) && clearFieldError(col)==false) ? 'is-danger': ''">
                                                            <div class="block radio-block">
                                                                <b-radio 
                                                                    v-for="opt in col.options"
                                                                    v-bind:key="opt.optionId"
                                                                    v-bind:name="'radio'+col.fieldId"
                                                                    v-bind:native-value="opt.optionValue"
                                                                    v-model="col.fieldAnswerValue"
                                                                    v-bind:required="col.isRequired">
                                                                    {{opt.optionValue}}
                                                                </b-radio>
                                                            </div>
                                                        </b-field>

                                                        <!-- *** DATE INPUT *** -->

                                                        <!-- Date Inputs -->
                                                        <b-field
                                                            v-if="col.inputType=='date' || 
                                                                    col.inputType=='date range (start date)' ||
                                                                    col.inputType=='date range (end date)'"
                                                            :type="(hasError(col.fieldId) && clearFieldError(col)==false) ? 'is-danger': ''">
                                                                <b-datepicker
                                                                v-bind:show-week-number="true"
                                                                placeholder="Click to select..."
                                                                icon="calendar-today"
                                                                v-model="col.fieldAnswerValue"
                                                                v-bind:required="col.isRequired">
                                                            </b-datepicker>
                                                        </b-field>

                                                    </td>
                                                    <td v-if="selectedForm && selectedForm.filesEnabled">
                                                        <!-- Files section -->
                                                        <b-notification
                                                            v-if="vfe"
                                                            v-bind:active.sync="vfe.fileUploadError" 
                                                            type="is-danger"
                                                            aria-close-label="Close notification"
                                                            role="alert">
                                                            {{vfe.fileUploadErroMsg}}
                                                        </b-notification>

                                                        <b-field grouped>
                                                            <a 
                                                                v-if="vfe && vfe.files && vfe.files.length > 0"
                                                                class="button has-text-weight-bold"
                                                                type="button"
                                                                v-on:click="showVfeFiles(vfe)">    
                                                                <i class="fas fa-file"></i>&nbsp;
                                                                <span>Files ({{vfe.files.length}})</span>
                                                            </a> &nbsp;&nbsp;

                                                            <b-field class="file"
                                                                v-if="vfe && vfe.dropFiles">
                                                                <b-upload 
                                                                    v-model="vfe.dropFiles"
                                                                    multiple
                                                                    v-on:input="checkFileTable(vfe)"
                                                                    v-bind:disabled="vfe && vfe.dropFiles && vfe.dropFiles.length==maxNumFiles">
                                                                    <a class="button is-primary is-outlined">
                                                                        <b-icon icon="upload"></b-icon>
                                                                        <span>Choose file</span>
                                                                    </a>
                                                                </b-upload>
                                                            </b-field>
                                                        </b-field>
                                                        <b-field
                                                            v-if="vfe && vfe.dropFiles">
                                                            <div class="tags">
                                                                <span v-for="(file, index) in vfe.dropFiles"
                                                                    v-bind:key="index"
                                                                    class="tag is-info" >
                                                                    {{file.name}} ({{convertFileSize(file.size)}})
                                                                    <button class="delete is-small"
                                                                        type="button"
                                                                        v-on:click="deleteDropFileTable(vfe,index)">
                                                                    </button>
                                                                </span>
                                                                <span
                                                                    v-if="vfe.dropFiles.length > 0" 
                                                                    class="tag is-dark is-small">
                                                                    Total File Size: {{getTotalFileSizeTable(vfe.dropFiles)}}
                                                                </span>
                                                            </div>
                                                        </b-field>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-if="selectedForm">
                                                <tr v-if="selectedForm && selectedForm.vfe.length == 0 && selectedForm.formFields">
                                                    <td v-bind:colspan="selectedForm.formFields.length + 1">
                                                        No entries available.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td v-bind:colspan="selectedForm.formFields.length + 1">
                                                        <a class="button is-light"
                                                            v-if="selectedForm && selectedForm.formSubmissionType=='Multiple' && displayOption=='Table'"
                                                            v-on:click="addFormTableEntry('workspace')">
                                                            <span class="icon">
                                                                <i class="fas fa-plus"></i>
                                                            </span>
                                                            <span>Add New Entry</span>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </section>
                            </div>
                            
                            <!-- Empty State -->
                            <section v-if="vfePromiseLoading">
                                <b-loading 
                                    v-bind:is-full-page="isFullPage" 
                                    v-bind:active.sync="vfePromiseLoading" 
                                    v-bind:can-cancel="false">
                                    <b-icon
                                        pack="fas"
                                        icon="sync-alt"
                                        size="is-medium"
                                        custom-class="fa-spin">
                                    </b-icon>
                                    &nbsp;&nbsp;&nbsp;
                                    <span class="title is-5">Loading form</span>
                                </b-loading>
                            </section>

                            <div v-if="selectedForm==null && !vfePromiseLoading"
                                class="base-box  box-hw--fill base-box--padded empty-state-box">
                                <!-- Add image here -->
                                <p class="title has-text-grey-light">No form selected</p>
                                <p class="subtitle has-text-grey-light">Please select one from the list to your left.</p>
                            </div>

                            <div v-if="selectedForm && !vfePromiseLoading && displayOption!='Table' && selectedVfe==null"
                                class="base-box  box-hw--fill base-box--padded empty-state-box">
                                <!-- Add image here -->
                                <p class="title has-text-grey-light">No form selected</p>
                                <p class="subtitle has-text-grey-light">Please select one from the list to your left.</p>
                            </div>
                        </div>

                    </div>
                </b-tab-item>

                <!-- Show Logs Here -->
                <b-tab-item label="Logs"
                    icon-pack="fa"
                    icon="user-clock">
                    <p class="is-italic">
                        Not updated? Click <a v-on:click="refreshData(false)">here</a> to get latest logs.
                    </p>
                    <div v-if="vcardLogs.length==0"
                        class="base-box  box-hw--fill base-box--padded empty-state-box">
                        <p class="title has-text-grey-light">No logs found</p>
                    </div>
                    <div v-if="vcardLogs.length > 0">
                        <div class="timeline">
                            <!-- Show this if status is validated and submitted already -->
                            <header class="timeline-header"
                                v-if="selectedValidationCard && selectedValidationCard.validationCardStatus=='Validated and Submitted'">
                                <span class="tag is-medium is-dark">End </span>
                            </header>
                            <div class="timeline-item"
                                v-for="log in vcardLogs"
                                v-bind:key="log.logId">
                                <div class="timeline-marker">
                                    <!-- <div class="timeline-marker is-image is-32x32"> 
                                            <img src="http://bulma.io/images/placeholders/32x32.png"> -->
                                    <!-- <div class="timeline-marker is-icon">
                                        <i class="fa fa-flag"></i> -->
                                </div>
                                <div class="timeline-content">
                                    <p class="heading">{{log.activityDate}} by {{log.activityByUserName}}</p>
                                    <p>{{log.activityMessageLog}}</p>
                                    <p
                                        v-if="log.additionalInfo"
                                        class="is-italic">
                                        {{log.additionalInfo.activity}}
                                    </p>
                                    <p
                                        v-if="log.activityReason">
                                        <strong>Reason :</strong> {{log.activityReason}}
                                    </p>
                                    <p v-if="log.activitySection=='Validation Card - Form Entry'"><span class="has-text-weight-bold">Form Name:</span> {{log.formName}}</p>
                                    <div v-if="log.activityBody && !log.activityReason">
                                        <table 
                                            width="100%"
                                            cellpadding="5"
                                            cellspacing="6"
                                            class="activity-log-table"
                                            v-if="log.changedFields">
                                            <thead>
                                                <tr>
                                                    <th>Field</th>
                                                    <th>Old Value</th>
                                                    <th>New Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr 
                                                    v-for="(ch,chIdx) in log.changedFields"
                                                    v-bind:key="chIdx">
                                                    <td>{{ch.fieldLabel}}</td>
                                                    <td>
                                                        <span class="strikethrough">{{ch.oldValue}}</span>
                                                    </td>
                                                    <td>{{ch.newValue}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p v-else
                                            class="is-italic">
                                            {{log.activityBody}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <header class="timeline-header">
                                <span class="tag is-medium is-dark">Start</span>
                            </header>
                        </div>
                    </div>
                </b-tab-item>

                <b-tab-item label="Preview"
                    icon-pack="fas"
                    icon="eye">
                    <SummaryTab 
                        v-if="selectedValidationCardId"
                        :selectedVcardId="selectedValidationCardId" />
                </b-tab-item>
            </b-tabs>

        </section>

        <section class="base-box--loading"
            v-if="isLoading">
            <b-loading 
                v-bind:is-full-page="isFullPage" 
                v-bind:active.sync="isLoading"
                >
                <b-icon
                    pack="fas"
                    icon="sync-alt"
                    size="is-medium"
                    custom-class="fa-spin">
                </b-icon>
                &nbsp;&nbsp;&nbsp;
                <span class="title is-5">Loading workspace</span>
            </b-loading>
        </section>

        <!-- Empty State -->
        <section class="section no-padd--top app-view app-view--user"
            v-if="!selectedValidationCardId && !isLoading">
            <div
                class="has-text-centered empty-state-box empty-state-box--white padd-top--lrg" >
                <div class="has-text-centered"
                    v-if="inProgressVcards.length > 0">
                    <p class="title is-5">There's no selected validation card.</p>
                    <p class="subtitle">To get started, select from the dropdown next to Reporting Year.</p>
                </div>
                <div class="has-text-centered"
                    v-if="inProgressVcards.length == 0">
                    <p class="title is-5">There are no validation cards that are 'In Progress' for the selected reporting year.</p>
                </div>
            </div>   
        </section>

        <!-- VFE Files (for table view) -->
        <b-modal
            has-modal-card
            v-bind:active.sync="openVfeFilesDialog"
            v-on:close="closeVfeFilesDialog">
            <div class="modal-card"
                v-if="openedVfe">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{openedVfe.formName}}</p>
                </header>
                <section class="modal-card-body">
                    <p class="subtitle is-4">Supporting Schedules and Documents ({{openedVfe.files.length}})</p>
                    <p v-if="openedVfe.files.length==0">No supporting schedules and/or documents uploaded.</p> 
                    <ul v-if="openedVfe && openedVfe.files.length > 0"
                        class="vfe-files-list">
                        <li v-for="(file,fileIdx) in openedVfe.files"
                            v-bind:key="fileIdx">                            
                            <span class="subtitle is-5">{{file.vfeFileTitle}}</span>
                            <div class="has-text-left">
                                Uploaded by {{file.uploadedByName}} on 
                                {{file.dateUploaded}}
                            </div>
                            <div class="buttons">
                                <a class="button is-light"
                                    type="button"
                                    v-on:click="confirmDeleteFile(file,fileIdx)">
                                    <span class="icon">
                                        <i class="fas fa-trash-alt"></i>
                                    </span>
                                    <span>Delete</span>
                                </a>
                                <a class="button is-light"
                                    type="button"
                                    v-on:click="openFile(file)">
                                    <span class="icon">
                                        <i class="fas fa-external-link-alt"></i>
                                    </span>
                                    <span>Open</span>
                                </a>
                            </div>
                        </li>
                    </ul>
                </section>
                <footer class="modal-card-foot has-text-left">
                    <a class="button is-white"
                        v-on:click="closeVfeFilesDialog">
                        <span>Close</span>
                    </a>
                </footer>
            </div>
        </b-modal>
        
    </section>
</template>

<style scoped>
/* List Panel */
.collapse-header {
    background-color: whitesmoke;
}
.collapse-action {
    margin-top: 0.6em;
}
.form-entry-box {
    border-radius: 0px;
    margin: 0px;
    margin-bottom: 0px !important;
}
.new-form-entry-box {
    padding: 1em;
}
.add-entry {
    border-radius: 0px;
    box-shadow: none;
    border: 2px dashed rgb(230, 230, 230);
}
.active-form-entry {
    font-weight: bold;
    border: 2px solid rgb(255, 187, 0);
}
/* Workspace Panel */
.app-view .b-tabs {
    height: 100%;
    min-height:100%;
}
.workspace-panel {
    min-height:100%;
}
.main-form-body {
    /* max-height:265px;
    overflow-y:scroll;
    overflow-x:hidden; */
}
.form-name {
    margin-top: 0.83rem;
    margin-bottom: 0.4rem !important;
}
.vfe-files-list {
    margin-bottom:2rem;
}
.vfe-files-list li {
    padding: 0.75rem;
    border-bottom:1px solid #efefef;
}
.vfe-files-list li:last-child {
    border-bottom:0px solid transparent;
}
.vfe-files-list li .subtitle {
    margin-top: 0.45rem;
}

.checkbox-block > .checkbox,
.radio-block > .radio {
    margin-top: 0.6rem;
    margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/workspace/WorkspaceView.vue